export default {
  'header.homepage': 'Página Inicial',
  'header.workspace': 'Espaço de Trabalho',
  'login.title': 'Seedance',
  'login.welcome': 'Bem-vindo ao Seedance',
  'login.description': 'Seedance é sua plataforma de geração de vídeo com IA. Serviços seguros e convenientes. Acesse todos os seus arquivos a qualquer hora e em qualquer lugar.',
  'login.email.placeholder': 'Email ou nome de usuário',
  'login.password.placeholder': 'Senha',
  'login.button': 'Entrar',
  'login.loading': 'Entrando...',
  'login.divider': 'ou',
  'login.signup': 'Não tem uma conta?',
  'login.signup.link': 'Registre-se',
  'login.error.default': 'Falha no login, tente novamente mais tarde',
  'login.success': 'Login realizado',
  'login.forgotPassword': 'Esqueceu a senha?',
  'login.forgotPassword.link': 'Redefinir aqui',
  'login.rememberPassword': 'Lembrar senha',
  'login.social.comingSoon': 'Este método de login estará disponível em breve',
  'captcha.placeholder': 'Código captcha',
  'captcha.refresh': 'Atualizar captcha',
  'auth.modal.title': 'Login necessário',
  'auth.modal.content': 'A sua sessão expirou ou não iniciou sessão. Por favor, inicie sessão para continuar.',
  'auth.modal.ok': 'Ir para login',
  'auth.modal.cancel': 'Mais tarde',
  'signup.title': 'Seedance',
  'signup.welcome': 'Bem-vindo ao Seedance',
  'signup.description': 'Crie sua conta e comece sua jornada de criação com IA',
  'signup.feature.ai': 'Alimentado por IA',
  'signup.feature.video': 'Criação de Vídeo',
  'signup.feature.fast': 'Geração Rápida',
  'signup.feature.creative': 'Criatividade Ilimitada',
  'signup.username.placeholder': 'Digite o nome de usuário',
  'signup.email.placeholder': 'Digite o email',
  'signup.password.placeholder': 'Digite a senha',
  'signup.confirmPassword.placeholder': 'Confirme a senha',
  'signup.inviteCode.placeholder': 'Código de convite (opcional)',
  'signup.button': 'Registrar',
  'signup.loading': 'Registrando...',
  'signup.login': 'Já tem uma conta?',
  'signup.login.link': 'Entrar',
  'signup.error.passwordMismatch': 'As senhas não correspondem',
  'signup.error.default': 'Falha no registro, tente novamente mais tarde',
  'signup.success': 'Registro concluído',
  'signup.username.rule.length': 'O nome de usuário deve ter entre 4 e 10 caracteres',
  'signup.username.rule.format': 'Apenas letras, números, sublinhados e hífens são permitidos',
  'signup.password.rule.length': 'A senha deve ter entre 6 e 20 caracteres',
  'signup.password.rule.lowercase': 'Deve conter letras minúsculas',
  'signup.password.rule.uppercase': 'Deve conter letras maiúsculas',
  'signup.password.rule.number': 'Deve conter números',
  'signup.password.rule.special': 'Deve conter caracteres especiais',
  'resetPassword.page.title': 'Redefinir senha - Seedance',
  'resetPassword.page.description': 'Redefina a senha da sua conta Seedance',
  'resetPassword.title': 'Redefinir senha',
  'resetPassword.email.placeholder': 'Digite seu endereço de email',
  'resetPassword.code.placeholder': 'Digite o código de verificação',
  'resetPassword.password.placeholder': 'Digite a nova senha',
  'resetPassword.button': 'Redefinir',
  'resetPassword.button.loading': 'Redefinindo...',
  'resetPassword.backToLogin': 'Voltar ao login',
  'resetPassword.sendCode': 'Obter código',
  'resetPassword.sendCode.sending': 'Enviando...',
  'resetPassword.sendCode.retry': 'Tentar novamente em {seconds}s',
  'resetPassword.error.emailRequired': 'Por favor, digite seu endereço de email',
  'resetPassword.error.codeRequired': 'Por favor, digite o código de verificação',
  'resetPassword.error.passwordRequired': 'Por favor, digite a nova senha',
  'resetPassword.error.passwordLength': 'A senha deve ter entre 6 e 20 caracteres',
  'resetPassword.error.codeLength': 'O código de verificação deve ter 6 dígitos',
  'resetPassword.success.codeSent': 'O código de verificação foi enviado para seu email',
  'resetPassword.success.reset': 'Senha redefinida com sucesso',
  'resetPassword.error.sendFailed': 'Falha ao enviar o código de verificação, tente novamente mais tarde',
  'resetPassword.error.resetFailed': 'Falha ao redefinir a senha, tente novamente mais tarde',
  'resetPassword.error.incomplete': 'Por favor, preencha todos os campos obrigatórios',
  'resetPassword.subtitle': 'Digite seu endereço de email e uma nova senha para redefinir o acesso à sua conta.',
  'resetPassword.email.label': 'Email',
  'resetPassword.code.label': 'Código de verificação',
  'resetPassword.password.label': 'Nova senha',
  'resetPassword.success.title': 'Redefinição bem-sucedida',
  'resetPassword.success.description': 'Sua senha foi atualizada com sucesso. Agora você pode fazer login com sua nova senha.',
  'resetPassword.goToLogin': 'Fazer login',
  'resetPassword.promo.title': 'Proteja sua conta, preserve sua criatividade.',
  'resetPassword.promo.description': 'Implementamos protocolos de segurança de nível bancário para garantir que seus dados e criações permaneçam exclusivamente seus.',
  'signup.verificationCode.placeholder': 'Digite o código de verificação',
  'signup.verificationCode.send': 'Obter código',
  'signup.verificationCode.sending': 'Enviando...',
  'signup.verificationCode.retry': 'Tentar novamente em {seconds}s',
  'signup.verificationCode.success': 'Código de verificação enviado',
  'signup.verificationCode.error': 'Falha ao enviar o código',
  'signup.verificationCode.required': 'Por favor, digite o código de verificação',
  'signup.verificationCode.invalid': 'Formato de código de verificação inválido',
  'signup.error.emailRequired': 'Por favor, digite seu endereço de email',
  'signup.announcement': 'A função de registro está em manutenção hoje!',
  'sidebar.create': 'Criar',
  'sidebar.allFiles': 'Todos os arquivos',
  'sidebar.starred': 'Favoritos',
  'sidebar.folders': 'Pastas',
  'sidebar.trash': 'Lixeira',
  'sidebar.decrypt': 'Ferramenta de descriptografia',
  'sidebar.promptMarket': 'Prompt Market',
  'sidebar.channels': 'Canais',
  'sidebar.dailyChallenge': 'Desafio Diário',
  'sidebar.mediaTools': 'Ferramentas de Mídia',
  'sidebar.storageNodes': 'Nós de Armazenamento',
  'create.tab.textToImage': 'Texto para Imagem',
  'create.tab.textToVideo': 'Texto para Vídeo',
  'create.tab.imageToImage': 'Imagem para Imagem',
  'create.tab.imageToVideo': 'Imagem para Vídeo',
  'create.tab.seedanceVideo': 'Seedance Imagem para Vídeo',
  'create.seedance.title': 'Seedance Imagem para Vídeo',
  'create.seedance.subtitle': 'ByteDance Doubao Seedance 1.5, geração de vídeos curtos orientada por imagem',
  'create.seedance.noModel': 'Nenhum modelo Seedance disponível. Configure no painel de administração.',
  'create.seedance.cameraFixed': 'Câmara fixa',
  'create.seedance.cameraFixed.true': 'Sim (fixa)',
  'create.seedance.cameraFixed.false': 'Não (dinâmica)',
  'create.seedance.watermark': 'Adicionar marca de água',
  'create.seedance.watermark.true': 'Sim',
  'create.seedance.watermark.false': 'Não',
  'create.textToImage.title': 'Texto para Imagem',
  'create.textToImage.subtitle': 'Digite uma descrição e deixe a IA desenhar a imagem em sua mente',
  'create.textToImage.description': 'Gerar imagens a partir de descrições de texto. Esta funcionalidade está em desenvolvimento...',
  'create.textToVideo.title': 'Texto para Vídeo',
  'create.textToVideo.subtitle': 'Digite descrições de cenas e controles de câmera para gerar vídeos de alta qualidade',
  'create.textToVideo.description': 'Gerar vídeos a partir de descrições de texto. Esta funcionalidade está em desenvolvimento...',
  'create.imageToImage.title': 'Imagem para Imagem',
  'create.imageToImage.description': 'Gerar novas imagens a partir de imagens de referência. Esta funcionalidade está em desenvolvimento...',
  'create.imageToVideo.title': 'Imagem para Vídeo',
  'create.imageToVideo.description': 'Gerar vídeos a partir de imagens de referência. Esta funcionalidade está em desenvolvimento...',
  'sidebar.feedback': 'Feedback',
  'sidebar.about': 'Sobre',
  'sidebar.productLog': 'Atualizações',
  'promptMarket.title': 'Prompt Market',
  'promptMarket.subtitle': 'Explore receitas de inspiração IA dos melhores criadores e libere seu potencial criativo',
  'promptMarket.searchPlaceholder': 'Pesquisar prompts, estilos, modelos...',
  'promptMarket.search': 'Pesquisar',
  'promptMarket.all': 'Todos',
  'promptMarket.tabAll': 'Recomendado',
  'promptMarket.tabImage': 'Texto para imagem',
  'promptMarket.tabVideo': 'Texto para vídeo',
  'promptMarket.tabAudio': 'Texto para música',
  'promptMarket.sortLatest': 'Mais recente',
  'promptMarket.sortHot': 'Popular',
  'promptMarket.sortSales': 'Mais vendidos',
  'promptMarket.publish': 'Publicar',
  'promptMarket.empty': 'Nenhum conteúdo. Seja o primeiro a publicar!',
  'promptMarket.free': 'Grátis',
  'promptMarket.token': 'TOKEN',
  'promptMarket.loadFailed': 'Falha ao carregar',
  'promptMarket.listSuccess': 'Publicado com sucesso',
  'promptMarket.listFailed': 'Falha ao publicar',
  'market.label': 'MERCADO DE PROMPTS',
  'market.h1': 'Liberte sua',
  'market.h1.highlight': 'inteligência criativa.',
  'market.sub': 'O destino premium para prompts de IA: imagem, vídeo e música. Receitas verificadas para OpenAI, Google, Midjourney, Runway, Kling, Luma, Suno, ElevenLabs e mais. Pare de adivinhar, comece a criar.',
  'market.providers.title': 'Compatível com os principais modelos e plataformas',
  'market.card1.title': 'Integração instantânea',
  'market.card1.desc': 'Pule a curva de aprendizado do prompt engineering. Importe prompts testados para o seu fluxo de trabalho com um clique.',
  'market.card2.title': 'Monetize sua criatividade',
  'market.card2.desc': 'Transforme seus melhores prompts em renda passiva. Junte-se a milhares de criadores que ganham com sua expertise em IA.',
  'market.card3.title': 'Qualidade verificada',
  'market.card3.desc': 'Cada listing é revisado e testado manualmente. Garantimos resultados consistentes em diferentes modelos.',
  'market.card4.title': 'Explorar o laboratório',
  'market.card4.desc': 'Descubra mais de 10.000 ativos gerados pela comunidade.',
  'market.cta': 'Abrir Mercado de Prompts',
  'home.mediaTools.title': 'Ferramentas de mídia',
  'home.mediaTools.subtitle': 'Uso online, sem instalação. Processe facilmente imagens, vídeo e áudio.',
  'home.mediaTools.toolSuffix': '',
  'home.mediaTools.imageCompress.title': 'Comprimir imagem',
  'home.mediaTools.imageCompress.description': 'Compressão inteligente mantendo a qualidade. Processamento em lote.',
  'home.mediaTools.videoCompress.title': 'Comprimir vídeo',
  'home.mediaTools.videoCompress.description': 'Compressão eficiente com resolução e bitrate personalizáveis. Múltiplos formatos.',
  'home.mediaTools.audioCompress.title': 'Comprimir áudio',
  'home.mediaTools.audioCompress.description': 'Otimize o tamanho mantendo a clareza. MP3, AAC e mais.',
  'filelist.column.name': 'Nome',
  'filelist.column.size': 'Tamanho',
  'filelist.column.updateTime': 'Modificado',
  'filelist.column.recycletime': 'Data de exclusão',
  'filelist.column.actions': 'Ações',
  'filelist.total': 'Total de {total} itens',
  'filelist.action.upload': 'Enviar',
  'filelist.action.newFolder': 'Nova pasta',
  'filelist.action.refresh': 'Atualizar',
  'filelist.action.search': 'Buscar arquivos',
  'filelist.action.batchDownload': 'Baixar',
  'filelist.action.batchDelete': 'Excluir',
  'filelist.selected': '{count} selecionados',
  'page.cloudDrive.title': 'Meu Cloud Drive',
  'page.cloudDrive.description': 'AIMATEX Cloud Drive - Armazene e gerencie seus arquivos com segurança',
  'modal.fileUpload.title': 'Enviar arquivos',
  'modal.fileUpload.dragText': 'Arraste arquivos aqui ou clique para enviar',
  'modal.fileUpload.start': 'Iniciar envio',
  'modal.fileUpload.cancel': 'Cancelar',
  'modal.fileUpload.clear': 'Limpar lista',
  'modal.fileUpload.encrypt': 'Criptografar selecionados',
  'modal.fileUpload.addMore': 'Adicionar',
  'modal.fileUpload.remove': 'Remover',
  'modal.fileUpload.error.noSelection': 'Selecione arquivos para remover',
  'modal.fileUpload.error.noEncryption': 'Selecione arquivos para criptografar',
  'modal.fileUpload.error.noClear': 'Não há arquivos para limpar',
  'modal.fileUpload.error.noStart': 'Não há arquivos para enviar',
  'modal.fileUpload.error.noCancel': 'Não há envios ativos para cancelar',
  'modal.fileUpload.error.fileSize': 'Tamanho do arquivo excedido',
  'modal.fileUpload.error.fileType': 'Tipo de arquivo não suportado',
  'modal.fileUpload.error.maxCount': 'Número máximo de arquivos excedido',
  'modal.fileUpload.duplicate.title': 'Arquivo já existe',
  'modal.fileUpload.duplicate.skip': 'Pular',
  'modal.fileUpload.duplicate.replace': 'Substituir',
  'modal.fileUpload.duplicate.rename': 'Renomear',
  'modal.fileUpload.status.pending': 'Pendente',
  'modal.fileUpload.status.uploading': 'Enviando',
  'modal.fileUpload.status.success': 'Concluído',
  'modal.fileUpload.status.error': 'Erro',
  'modal.fileUpload.status.cancelled': 'Cancelado',
  'modal.fileUpload.status.duplicated': 'Duplicado',
  'modal.fileUpload.table.filename': 'Nome do arquivo',
  'modal.fileUpload.table.size': 'Tamanho',
  'modal.fileUpload.table.status': 'Status',
  'modal.fileUpload.table.progress': 'Progresso',
  'modal.fileUpload.table.actions': 'Ações',
  'modal.fileUpload.speed': 'Velocidade de envio',
  'modal.fileUpload.remainingTime': 'Tempo restante',
  'modal.fileUpload.total.progress': 'Progresso total',
  'modal.fileUpload.error.message': 'Erro no envio: {message}',
  'modal.fileUpload.confirm.clear': 'Deseja limpar a lista de envio?',
  'modal.fileUpload.confirm.cancel': 'Deseja cancelar o envio?',
  'modal.fileUpload.clear.mobile': 'Limpar',
  'modal.fileUpload.encrypt.mobile': 'Criptografar',
  'modal.fileUpload.addMore.mobile': 'Adicionar',
  'modal.newFolder.title': 'Nova pasta',
  'modal.newFolder.placeholder': 'Digite o nome da pasta',
  'modal.newFolder.ok': 'Criar',
  'modal.newFolder.cancel': 'Cancelar',
  'productLog.title': 'Atualizações do produto',
  'page.decrypt.title': 'Ferramenta de descriptografia de arquivos MyStorage',
  'page.decrypt.subtitle': 'Descriptografe seus arquivos com segurança',
  'page.decrypt.helmet.title': 'Ferramenta de descriptografia - MyStorage',
  'page.decrypt.helmet.description': 'Ferramenta segura de descriptografia - Descriptografe seus arquivos localmente no navegador para proteger sua privacidade',
  'decrypt.upload.dragText': 'Clique ou arraste arquivos',
  'decrypt.upload.hint': 'Suporta arquivos .encrypted, máximo {maxSize} por arquivo',
  'decrypt.upload.button.decrypt': 'Descriptografar selecionados',
  'decrypt.upload.button.clear': 'Limpar lista',
  'decrypt.fileList.empty': 'Não há arquivos, adicione arquivos para descriptografar',
  'decrypt.fileList.column.name': 'Nome do arquivo',
  'decrypt.fileList.column.size': 'Tamanho',
  'decrypt.fileList.column.status': 'Status',
  'decrypt.fileList.column.actions': 'Ações',
  'decrypt.fileList.status.pending': 'Pendente',
  'decrypt.fileList.status.decrypting': 'Descriptografando',
  'decrypt.fileList.status.success': 'Concluído',
  'decrypt.fileList.status.error': 'Erro',
  'decrypt.fileList.action.info': 'Info',
  'decrypt.password.modal.title': 'Digite a senha de descriptografia',
  'decrypt.password.modal.placeholder': 'Digite a senha',
  'decrypt.password.modal.hint': 'Digite a senha definida durante a criptografia, ela será usada apenas para descriptografia local',
  'decrypt.security.modal.title': 'Aviso de segurança',
  'decrypt.security.modal.description': 'Todas as operações de descriptografia são realizadas localmente, sua senha e o conteúdo do arquivo nunca serão enviados ao servidor',
  'signup.page.title': 'Registro - Seedance',
  // Recursos de segurança
  'security.features.title': 'Recursos de segurança',
  'security.features.localDecryption.title': 'Proteção de descriptografia local',
  'security.features.localDecryption.description': 'Todas as operações de descriptografia são realizadas localmente em seu navegador, garantindo que o conteúdo de seus arquivos e senhas nunca sejam carregados nos servidores',
  'security.features.militaryEncryption.title': 'Criptografia de nível militar',
  'security.features.militaryEncryption.description': 'Utiliza o algoritmo de criptografia AES-256-CBC, o padrão de criptografia simétrica mais seguro disponível que pode resistir a todos os métodos de ataque conhecidos',
  'security.features.privacyProtection.title': 'Proteção de dados privados',
  'security.features.privacyProtection.description': 'Mecanismos rigorosos de proteção de privacidade garantem que nenhuma senha de descriptografia seja armazenada e nenhum conteúdo de arquivo seja registrado',
  'security.features.smartDecryption.title': 'Descriptografia inteligente em blocos',
  'security.features.smartDecryption.description': 'Utiliza tecnologia de descriptografia inteligente em blocos para melhorar significativamente a velocidade de descriptografia enquanto reduz consideravelmente o uso de memória',
  'security.features.learnMore': 'Saiba mais',
  'security.features.modal.title': 'Detalhes dos recursos de segurança',
  'security.features.modal.close': 'Fechar',
  // Modal de dicas de segurança
  'decrypt.security.modal.vip.title': 'Caro usuário VIP, você pode:',
  'decrypt.security.modal.vip.feature1': 'Descriptografar arquivos de qualquer tamanho',
  'decrypt.security.modal.vip.feature2': 'Usar descriptografia inteligente em blocos para maior eficiência e menor uso de memória',
  'decrypt.security.modal.vip.feature3': 'Suportar descriptografia em lote de múltiplos arquivos grandes',
  'decrypt.security.modal.free.title': 'Importante: O processo de descriptografia requer memória do navegador, o uso real de memória é aproximadamente 3 vezes o tamanho do arquivo.',
  'decrypt.security.modal.free.feature1': 'Usuários não VIP estão limitados a 4GB por arquivo',
  'decrypt.security.modal.free.feature2': 'Faça upgrade para VIP para descriptografar arquivos de qualquer tamanho e habilitar a descriptografia em blocos',
  'decrypt.security.modal.free.feature3': 'Se o navegador travar, faça upgrade para VIP para usar o recurso de descriptografia em blocos',
  // Diagrama de criptografia CBC
  'security.diagram.plaintext.block1': 'Bloco de texto simples 1',
  'security.diagram.plaintext.block2': 'Bloco de texto simples 2',
  'security.diagram.ciphertext.block1': 'Bloco cifrado 1',
  'security.diagram.ciphertext.block2': 'Bloco cifrado 2',
  'security.diagram.key': 'Chave de criptografia',
  'security.diagram.aes.encryption': 'Criptografia AES',
  // Smart Chunk Decryption
  'security.features.chunk.title': 'Tecnologia de Descriptografia Inteligente em Blocos',
  'security.features.chunk.what': 'O que é Descriptografia Inteligente em Blocos?',
  'security.features.chunk.description': 'A descriptografia inteligente em blocos é uma tecnologia otimizada para arquivos grandes que divide os arquivos em múltiplos blocos para processamento paralelo, com as seguintes características:',
  'security.features.chunk.feature1.title': 'Divisão Dinâmica',
  'security.features.chunk.feature1.desc': 'Ajusta automaticamente o tamanho dos blocos com base no tamanho do arquivo e memória do sistema',
  'security.features.chunk.feature2.title': 'Processamento Paralelo',
  'security.features.chunk.feature2.desc': 'Múltiplos blocos de dados são descriptografados simultaneamente, aproveitando ao máximo as CPUs multi-core',
  'security.features.chunk.feature3.title': 'Otimização de Memória',
  'security.features.chunk.feature3.desc': 'Controla o uso de memória através de processamento em streaming para evitar overflow',
  'security.features.chunk.feature4.title': 'Suporte à Retomada',
  'security.features.chunk.feature4.desc': 'Suporta continuação após interrupção, melhorando a tolerância a falhas',
  'security.features.chunk.how': 'Como Funciona',
  'security.features.chunk.process': 'O processo de descriptografia inteligente em blocos inclui as seguintes etapas:',
  'security.features.chunk.step1': 'Análise do Arquivo: Calcula o tamanho e quantidade ideal de blocos',
  'security.features.chunk.step2': 'Divisão de Dados: Divide o arquivo criptografado em blocos de tamanho igual',
  'security.features.chunk.step3': 'Descriptografia Paralela: Múltiplos blocos são descriptografados simultaneamente',
  'security.features.chunk.step4': 'Escrita em Stream: Os blocos descriptografados são escritos em sequência',
  'security.features.chunk.code': '{code}',
  'security.features.chunk.performance': 'Vantagens de Desempenho',
  'security.features.chunk.performance.intro': 'Em comparação com a descriptografia tradicional, a descriptografia inteligente em blocos tem vantagens significativas:',
  'security.features.chunk.performance.point1': 'Uso de memória reduzido em até 90%, apenas 400MB necessários para um arquivo de 4GB',
  'security.features.chunk.performance.point2': 'Velocidade de descriptografia 3-5 vezes mais rápida, aproveitando CPUs multi-core',
  'security.features.chunk.performance.point3': 'Suporta descriptografia de arquivos grandes (>4GB), não limitado pela memória do navegador',
  'security.features.chunk.performance.point4': 'Processo de descriptografia visual com progresso e tempo restante precisos',
  'security.features.chunk.usage': 'Casos de Uso',
  'security.features.chunk.usage.intro': 'A descriptografia inteligente em blocos é particularmente adequada para os seguintes cenários:',
  'security.features.chunk.usage.point1': 'Descriptografia de arquivos grandes (ex. vídeos, backups de banco de dados)',
  'security.features.chunk.usage.point2': 'Operações de descriptografia em dispositivos com memória limitada',
  'security.features.chunk.usage.point3': 'Descriptografia em lote que requer processamento paralelo',
  'security.features.chunk.usage.point4': 'Tarefas de descriptografia que requerem feedback em tempo real',
  'security.features.chunk.diagram': 'Diagrama do Processo de Descriptografia em Blocos',
  'security.features.aes.what': 'O que é AES-256-CBC?',
  'security.features.aes.description': 'AES-256-CBC é uma implementação do Advanced Encryption Standard (Padrão de Criptografia Avançada), onde:',
  'security.features.aes.detail.1': 'Um algoritmo de criptografia simétrica estabelecido pelo Instituto Nacional de Padrões e Tecnologia (NIST) dos EUA em 2001',
  'security.features.aes.detail.2': 'Utiliza chave de 256 bits, fornecendo o mais alto nível de segurança',
  'security.features.aes.detail.3': 'O modo Cipher Block Chaining (CBC) fornece melhor segurança de criptografia',
  'security.features.aes.how': 'Como funciona',
  'security.features.aes.process': 'O processo de criptografia AES-256-CBC inclui os seguintes passos:',
  'security.features.aes.step1': 'Dividir os dados de texto simples em blocos de tamanho fixo (128 bits)',
  'security.features.aes.step2': 'Gerar um vetor de inicialização (IV) aleatório',
  'security.features.aes.step3': 'Realizar operação XOR entre o bloco de texto cifrado anterior e o bloco de texto simples atual usando modo CBC',
  'security.features.aes.step4': 'Usar a chave de 256 bits para realizar a criptografia AES no resultado XOR',
  'security.features.aes.example': 'Exemplo do processo de criptografia:',
  'common.unknown': 'Desconhecido',
  'common.philosophy': 'A tecnologia deve servir o povo',
  'common.speed': 'Velocidade',
  'common.timeSpent': 'Tempo decorrido',
  'common.remaining': 'Restante',
  // File Info Modal
  'decrypt.fileInfo.modal.title': 'Informações do Arquivo',
  'decrypt.fileInfo.modal.close': 'Fechar',
  'decrypt.fileInfo.name': 'Nome do Arquivo',
  'decrypt.fileInfo.size': 'Tamanho do Arquivo',
  'decrypt.fileInfo.type': 'Tipo do Arquivo',
  'decrypt.fileInfo.lastModified': 'Última Modificação',
  'decrypt.fileInfo.status': 'Estado',
  'decrypt.fileInfo.progress': 'Progresso',
  'decrypt.fileInfo.speed': 'Velocidade',
  'decrypt.fileInfo.timeRemaining': 'Tempo Restante',
  'decrypt.fileInfo.timeSpent': 'Tempo Decorrido',
  'decrypt.fileInfo.error': 'Mensagem de Erro',
  'filelist.action.download': 'Baixar',
  'filelist.action.preview': 'Visualizar',
  'filelist.action.rename': 'Renomear',
  'filelist.modal.rename.title': 'Renomear',
  'filelist.modal.rename.placeholder': 'Digite o novo nome',
  'filelist.modal.rename.ok': 'OK',
  'filelist.modal.rename.cancel': 'Cancelar',
  'sideMenu.storageInfo.title': 'Espaço de armazenamento',
  'sideMenu.storageInfo.usage': 'Usado {used} / Total {total}',
  'sideMenu.storageStats.title': 'Estatísticas de armazenamento',
  'sideMenu.storageStats.overview': 'Visão geral',
  'sideMenu.storageStats.totalFiles': 'Total de arquivos',
  'sideMenu.storageStats.totalSize': 'Tamanho total',
  'sideMenu.storageStats.fileTypes': 'Distribuição de tipos de arquivo',
  'sideMenu.storageStats.providers': 'Provedores de serviço',
  'common.default': 'Padrão',
  'common.regionCode': 'Código da região',
  'common.nodeType': 'Tipo de nó',
  'common.storageUsed': 'Espaço usado',
  'common.storageAvailable': 'Espaço disponível',
  'common.storageLimit': 'Capacidade total',
  'common.storageUsageDetail': 'Usado {used} / Total {total}',
  'common.defaultNode': 'Nó padrão',
  'common.confirm': 'Confirmar',
  'common.cancel': 'Cancelar',
  'common.latency': 'Latência',
  'common.retry': 'Tentar novamente',
  'cloudDrive.nodeSelect.title': 'Selecionar nó de armazenamento',
  'cloudDrive.nodeSelect.addNode': 'Adicionar nó de armazenamento',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'Confirmar exclusão do nó',
  'cloudDrive.nodeSelect.deleteConfirm.content': 'Tem certeza de que deseja excluir o nó "{nodeName}"? Esta ação não pode ser desfeita!',
  'cloudDrive.nodeSelect.deleteSuccess': 'Nó excluído com sucesso',
  'cloudDrive.nodeSelect.deleteFailed': 'Falha ao excluir o nó',
  
  // Criação de nó
  'cloudDrive.nodeCreate.title': 'Adicionar nó de armazenamento',
  'cloudDrive.nodeCreate.selectProvider': 'Selecionar provedor de nuvem',
  'cloudDrive.nodeCreate.nodeName': 'Nome do nó',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': 'Deixe em branco para usar o nome padrão',
  'cloudDrive.nodeCreate.nameMaxLength': 'O nome do nó não pode exceder 50 caracteres',
  'cloudDrive.nodeCreate.noProviders': 'Nenhum provedor de nuvem disponível',
  'cloudDrive.nodeCreate.pingLatency': 'Latência {value} ms',
  'cloudDrive.nodeCreate.pingTesting': 'Testando latência...',
  'cloudDrive.nodeCreate.pingFailed': 'Falha ao testar a latência',
  'cloudDrive.nodeCreate.pingUnavailable': 'Teste de latência indisponível',
  'cloudDrive.nodeCreate.sortByLatency': 'Ordenar por latência',
  'cloudDrive.nodeCreate.selectRegion': 'Selecionar região',
  'cloudDrive.nodeCreate.selectedRegion': 'Região selecionada',
  'cloudDrive.nodeCreate.noRegions': 'Nenhuma região disponível',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'Selecione um provedor de nuvem',
  'cloudDrive.nodeCreate.selectProviderRequired': 'Por favor, selecione um provedor de nuvem primeiro',
  'cloudDrive.nodeCreate.selectRegionRequired': 'Por favor, selecione uma região primeiro',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'Falha ao carregar a lista de provedores de nuvem',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'Falha ao carregar a lista de regiões',
  'cloudDrive.nodeCreate.nodeType': 'Tipo de nó',
  'cloudDrive.nodeCreate.nodeType.standard': 'Armazenamento padrão',
  'cloudDrive.nodeCreate.nodeType.lowFreq': 'Armazenamento de baixa frequência',
  'cloudDrive.nodeCreate.nodeType.archive': 'Armazenamento de arquivo',
  'cloudDrive.nodeCreate.storageLimit': 'Limite de armazenamento',
  'cloudDrive.nodeCreate.storageLimitRequired': 'Por favor, insira o limite de armazenamento',
  'cloudDrive.nodeCreate.storageLimitMin': 'O limite de armazenamento não pode ser menor que 1GB',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'Digite o limite de armazenamento (GB)',
  'cloudDrive.nodeCreate.success': 'Nó de armazenamento criado com sucesso',
  'cloudDrive.nodeCreate.failed': 'Falha ao criar o nó de armazenamento',
  
  // Edição de nó
  'cloudDrive.nodeEdit.title': 'Editar nó',
  'cloudDrive.nodeEdit.name': 'Nome do nó',
  'cloudDrive.nodeEdit.nameRequired': 'Por favor, insira o nome do nó',
  'cloudDrive.nodeEdit.nameMaxLength': 'O nome do nó não pode exceder 50 caracteres',
  
  // TextToImage page internationalization
  'create.prompt': 'Prompt',
  'create.prompt.placeholder': 'ex.: um gato cyberpunk caminhando no espaço, fundo neon, alto detalhe...',
  'create.prompt.required': 'Por favor, insira um prompt',
  'create.prompt.generate': 'IA Gerar Prompt',
  'create.prompt.enrich': 'IA Enriquecer Prompt',
  'create.prompt.generate.success': 'Prompt gerado com sucesso!',
  'create.prompt.generate.error': 'Falha ao gerar prompt, por favor tente novamente',
  'create.prompt.generate.empty': 'Nenhum prompt gerado, por favor tente novamente',
  'create.prompt.restore': 'Restaurar',
  'create.prompt.restore.success': 'Restaurado para o prompt original',
  'create.prompt.restore.tooltip': 'Restaurar para o prompt antes da geração/enriquecimento da IA',
  'create.ratio': 'Proporção',
  'create.style': 'Estilo Artístico',
  'create.batchSize': 'Tamanho do Lote',
  'create.generate': 'Gerar Agora',
  'create.negativePrompt.tooltip': 'Elementos que você não quer na imagem',
  'create.negativePrompt.placeholder': 'ex.: desfocado, baixa qualidade, dedos deformados...',
  'create.generating': 'Gerando...',
  'create.generating.waiting': 'A IA está criando, aguarde...',
  'create.result.title': 'Resultados Gerados',
  'create.downloadAll': 'Baixar Tudo',
  'create.aspectRatio.1:1': '1:1 (Quadrado)',
  'create.aspectRatio.16:9': '16:9 (Paisagem)',
  'create.aspectRatio.9:16': '9:16 (Retrato)',
  'create.aspectRatio.21:9': '21:9 (Cinema)',
  'create.aspectRatio.4:3': '4:3 (Clássico)',
  'create.style.general': 'Geral',
  'create.style.anime': 'Anime',
  'create.style.realistic': 'Realista',
  'create.style.3d-render': '3D Render',
  'create.style.cyberpunk': 'Cyberpunk',
  'create.settings.loadFailed': 'Falha ao carregar configurações de tipo de criação, mostrando todas as opções',
  'create.settings.error': 'Falha ao carregar configurações, mostrando todas as opções',
  'create.noAvailableTabs': 'Nenhum tipo de criação disponível',
  'create.network.error.title': 'Erro de Conexão de Rede',
  'create.network.error.description': 'Não foi possível carregar as configurações de tipo de criação. Por favor, verifique sua conexão de rede e atualize a página',
  'create.network.error.refresh': 'Atualizar Página',
  
  // TextToVideo page internationalization
  'create.prompt.video': 'Descrição de Cena de Vídeo (Prompt)',
  'create.prompt.video.placeholder': 'ex., Um cão astronauta dançando na superfície lunar, 8K, iluminação cinematográfica, surrealismo.',
  'create.prompt.video.required': 'Por favor, insira uma descrição de cena de vídeo',
  'create.generate.video': 'Gerar Vídeo Agora',
  'create.video.ratio': 'Proporção de Aspecto do Vídeo',
  'create.video.camera': 'Movimento da Câmera',
  'create.video.duration': 'Duração do Vídeo (segundos)',
  'create.video.format': 'Formato de Saída',
  'create.cameraMotion.none': 'Sem Movimento (None)',
  'create.cameraMotion.zoomIn': 'Zoom In',
  'create.cameraMotion.dollyOut': 'Dolly Out',
  'create.cameraMotion.panLeft': 'Panorâmica Esquerda (Pan Left)',
  'create.cameraMotion.tiltUp': 'Inclinação Para Cima (Tilt Up)',
  'create.cameraMotion.orbital': '360° Orbital',
  'create.negativePrompt.video.placeholder': 'ex., marcas d\'água, cintilação, baixa resolução, personagens desfocados...',
  'create.sora.thinking': 'Sora está pensando...',
  'create.video.analyzing': 'Analisando imagem e prompt, a IA está criando...',
  'create.video.info': 'Duração: {duration}s | Proporção: {ratio}',
  'create.video.preview': 'Pré-visualização do Vídeo',
  'create.video.result': 'Pré-visualização Final do Vídeo',
  'create.video.empty': 'Os resultados gerados serão exibidos aqui',
  'create.download': 'Baixar Vídeo',
  'create.duration.format': '{duration}s',
  'create.duration.4s': '4s',
  'create.duration.8s': '8s',
  'create.duration.15s': '15s',
  'create.estimated.price': 'Estimado: {price}',
  'create.model.select': 'Selecionar Modelo',
  'create.model.loading': 'Carregando modelos...',
  'create.model.loadFailed': 'Falha ao carregar lista de modelos',
  'create.model.family.select': 'Selecionar Família de Modelos',
  'create.model.family.select.placeholder': 'Por favor selecione uma família de modelos',
  'create.model.family.loadFailed': 'Falha ao carregar lista de famílias de modelos',
  'create.style.select.placeholder': 'Por favor selecione um estilo artístico (opcional, padrão usa o modelo da família)',
  'create.model.style.loadFailed': 'Falha ao carregar lista de modelos de estilo',
  'create.model.description': 'Descrição do Modelo',
  'create.model.aspectResolution': 'Resolução de Proporção',
  'create.model.fps': 'Taxa de Quadros',
  'create.model.features': 'Recursos Suportados',
  'create.model.feature.cameraMotion': 'Movimento da Câmera',
  'create.model.feature.img2video': 'Imagem para Vídeo',
  'create.model.feature.videoEdit': 'Edição de Vídeo',
  'create.model.price.perSecond': '/seg',
  'create.model.detail': 'Detalhes',
  'create.history.title': 'Histórico de geração',
  'create.history.refresh': 'Atualizar',
  'create.history.empty': 'Nenhum histórico de geração',
  'create.history.total': 'Total {total} registros',
  'create.history.status.queued': 'Na fila',
  'create.history.status.processing': 'Processando',
  'create.history.status.success': 'Sucesso',
  'create.history.status.failed': 'Falhou',
  'create.history.status.timeout': 'Tempo esgotado',
  'create.history.failed.noImage': 'Geração falhou',
  'create.history.downloadAll.start': 'Iniciando download de {count} imagens',
  'create.history.downloadAll.tooltip': 'Baixar todas as {count} imagens',
  'create.history.download.tooltip': 'Baixar imagem',
  'create.history.detail.tooltip': 'Ver detalhes',
  'create.history.noPrompt': 'Sem prompt',
  'create.history.deleteConfirm.title': 'Confirmar exclusão',
  'create.history.deleteConfirm.content': 'Tem certeza de que deseja excluir esta tarefa? Esta ação não pode ser desfeita.',
  'create.history.deleteSuccess': 'Excluído com sucesso',
  'create.history.deleteFailed': 'Falha ao excluir',
  'create.taskDetail.title': 'Detalhes da tarefa',
  'create.taskDetail.loading': 'Carregando...',
  'create.taskDetail.loadFailed': 'Falha ao carregar detalhes da tarefa',
  'create.taskDetail.noData': 'Nenhum dado disponível',
  'create.taskDetail.basicInfo': 'Informações básicas',
  'create.taskDetail.model': 'Modelo',
  'create.taskDetail.taskType': 'Tipo de tarefa',
  'create.taskDetail.createTime': 'Hora de criação',
  'create.taskDetail.duration': 'Duração da geração',
  'create.taskDetail.prompt': 'Prompt',
  'create.taskDetail.error': 'Mensagem de erro',
  'create.taskDetail.outputFiles': 'Arquivos de saída',
  'create.taskDetail.downloadAll': 'Baixar tudo',
  'create.taskDetail.downloadAll.start': 'Iniciando download de {count} imagens',
  'create.taskDetail.modelInfo': 'Informações do modelo',
  'create.taskDetail.defaultResolution': 'Resolução padrão',
  'create.taskDetail.maxResolution': 'Resolução máxima',
  'create.taskDetail.aspectRatios': 'Proporções suportadas',
  'create.taskDetail.formats': 'Formatos suportados',
  'create.taskDetail.prompt.copied': 'Prompt copiado',
  'create.taskDetail.liked': 'Curtido',
  'create.taskDetail.like': 'Curtir',
  'create.taskDetail.collected': 'Coletado',
  'create.taskDetail.collect': 'Coletar',
  'create.taskDetail.linkCopied': 'Link copiado',
  'create.taskDetail.share': 'Compartilhar',
  'create.taskDetail.outputs': 'Saídas',
  'create.taskDetail.preview': 'Visualizar',
  'create.taskDetail.download': 'Baixar',
  'create.taskDetail.generationFailed': 'Geração falhou',
  'create.taskDetail.generating': 'Gerando...',
  'create.taskDetail.promptLabel': 'Prompt',
  'create.taskDetail.copy': 'Copiar',
  'create.taskDetail.executionStats': 'Estatísticas de execução',
  'create.taskDetail.creditsCost': 'Custo de créditos',
  'create.taskDetail.modelSpecs': 'Especificações do modelo',
  'create.taskDetail.capabilities': 'Capacidades',
  'create.taskDetail.supportedRatios': 'Proporções suportadas',
  'create.taskDetail.dataError': 'Erro de dados',
  'create.taskDetail.more': 'Mais',
  'create.taskDetail.downloading': 'Baixando...',
  'create.taskDetail.points': 'pts',
  'create.taskDetail.seconds': 's',
  'create.taskDetail.status.success': 'SUCESSO',
  'create.taskDetail.status.failed': 'FALHOU',
  'create.taskDetail.status.processing': 'PROCESSANDO',
  'create.taskDetail.status.queued': 'NA FILA',
  'create.taskDetail.status.generating': 'GERANDO',
  'create.taskDetail.durationLabel': 'Duração',
  'create.taskDetail.taskParams': 'Parâmetros da tarefa',
  'create.taskDetail.aspectRatio': 'Proporção',
  'create.taskDetail.inputType': 'Tipo de entrada',
  'create.taskDetail.modelCode': 'Código do modelo',
  'create.taskDetail.regenerate': 'Regenerar',
  'create.taskDetail.feature.developing': 'Funcionalidade em desenvolvimento',
  'create.taskDetail.result': 'Resultado da geração',
  'create.taskDetail.copyPrompt': 'Copiar solicitação',
  'create.taskDetail.imageDimensions': 'Dimensões',
  'create.taskDetail.fileSize': 'Tamanho do arquivo',
  'create.taskDetail.loadingImageInfo': 'Carregando informações da imagem...',
  'create.history.failed.noVideo': 'Geração falhou',
  'create.video.generate.cancelled.polling': 'Sondagem de tarefa cancelada',
  'create.video.generate.queued': 'Tarefa de geração de vídeo enviada, na fila...',
  'create.video.generate.noUrl': 'Geração de vídeo concluída, mas URL do vídeo não encontrada',
  'create.video.status.checkFailed': 'Falha ao verificar o status da tarefa',
  'create.video.generate.processing': 'Tarefa de geração de vídeo enviada, processando...',
  'create.video.taskQueue': 'Fila de tarefas',
  'create.video.polling': 'Gerando vídeo, aguarde...',
  'create.video.ratio.invalid': 'Por favor, selecione uma proporção de vídeo suportada pelo modelo',
  'create.waitingTask.queue': 'Fila de tarefas',
  'create.waitingTask.empty': 'Nenhuma tarefa em andamento',
  'create.waitingTask.generating': 'Gerando...',
  'create.waitingTask.queued': 'Na fila',
  'create.waitingTask.cancel': 'Cancelar tarefa',
  // HistorySection nova internacionalização
  'create.history.copyPrompt': 'Copiar prompt',
  'create.history.download': 'Baixar',
  'create.history.delete': 'Excluir',
  'create.history.generating': 'Gerando...',
  'create.history.generationFailed': 'Geração falhou',
  'create.history.noPreview': 'Sem pré-visualização',
  // ImageToVideo nova internacionalização
  'create.i2v.fileType.error': 'Por favor selecione um arquivo de imagem',
  'create.i2v.fileSize.error': 'O tamanho do arquivo de imagem não pode exceder 10 MB',
  'create.i2v.imageSize.error': 'A altura da imagem deve ser de pelo menos {minHeight}px, o tamanho atual da imagem é {width}x{height}px',
  'create.i2v.fileRead.error': 'Falha ao ler a imagem',
  'create.i2v.replaceImage': 'Substituir imagem',
  'create.i2v.upload.supportedFormats': 'Suporta JPG, PNG, WebP, JFIF',
  'create.i2v.upload.required': 'Por favor faça upload de uma imagem de referência',
  'create.i2v.upload': 'Fazer Upload de Imagem de Referência (Quadro Inicial)',
  'create.i2v.upload.click': 'Clique ou arraste para fazer upload',
  'create.i2v.prompt.required': 'Por favor insira uma descrição de orientação de movimento',
  'create.i2v.uploading.image': 'Enviando imagem para a nuvem...',
  'create.i2v.upload.success': 'Imagem enviada com sucesso',
  'create.i2v.upload.failed': 'Falha no envio da imagem, por favor tente novamente',
  'create.i2v.original': 'Original (quadro inicial)',
  'create.i2v.result': 'Comparação de geração',
  'create.i2v.empty': 'A comparação dos resultados gerados e da imagem original será exibida aqui',
  'create.generate.i2v': 'Iniciar geração de vídeo',
  'create.prompt.i2v.placeholder': 'Ex: Fazer a pessoa na imagem começar a caminhar, folhas no fundo balançando ao vento...',
  'create.prompt.enhance.tooltip': 'Enriquecer o prompt com IA para tornar a descrição mais detalhada e vívida',
  'create.prompt.enhance': 'Enriquecer com IA',
  'create.prompt.enhance.empty': 'Por favor insira primeiro um prompt base',
  'create.prompt.enhance.success': 'Prompt enriquecido com sucesso!',
  'create.prompt.enhance.empty.result': 'Nenhum prompt enriquecido gerado, por favor tente novamente',
  'create.prompt.enhance.error': 'Falha ao enriquecer o prompt, por favor tente novamente',
  'create.prompt.version.history': 'Histórico de Versões',
  'create.prompt.version.history.tooltip': 'Ver histórico de versões do prompt',
  // TaskDetailModal nova internacionalização
  'create.taskDetail.unnamedTask': 'Tarefa sem nome',
  'create.taskDetail.prompt.title': 'Prompt',
  'create.taskDetail.tokenCost': 'Custo de tokens',
  'create.taskDetail.publish': 'Publicar na comunidade',
  'create.taskDetail.selectCover': 'Selecionar capa',
  'create.taskDetail.selectChannel': 'Selecionar canal',
  'create.taskDetail.selectChallenge': 'Selecionar desafio',
  'create.taskDetail.publishSuccess': 'Publicado com sucesso',
  'create.taskDetail.loadChannelsFailed': 'Falha ao carregar canais',
  'create.taskDetail.loadChallengesFailed': 'Falha ao carregar desafios',
  'create.taskDetail.publishFailed': 'Falha ao publicar',
  'create.taskDetail.daysLeft': 'Faltam {days} dias',
  // ModelDetailModal nova internacionalização
  'create.model.capability.t2v': 'T2V (Texto para Vídeo)',
  'create.model.capability.img2video': 'Imagem para Vídeo',
  'create.model.capability.videoEdit': 'Edição de Vídeo',
  'create.model.capability.characterConsistency': 'Consistência de Personagens',
  'create.model.capability.reference': 'Referência',
  'create.model.capability.cameraMotion': 'Movimento de Câmera',
  'create.model.aspectRatios': 'Proporções',
  'create.model.resolution': 'Resolução',
  'create.model.resolution.default': 'Padrão',
  'create.model.resolution.max': 'Máximo',
  'create.model.duration': 'Duração',
  'create.model.formats': 'Formatos',
  'create.model.like': 'Curtir',
  'create.model.liked': 'Curtido',
  'create.model.unliked': 'Descurtido',
  'create.model.favorite': 'Favorito',
  'create.model.favorited': 'Adicionado aos favoritos',
  'create.model.unfavorited': 'Removido dos favoritos',
  'create.model.share': 'Compartilhar',
  'create.model.linkCopied': 'Link copiado',
  'create.model.capabilities': 'Capacidades',
  'create.model.free': 'Grátis',
  'create.model.tokenCost.display': '{count} token',
  // Outras novas chaves
  'create.aspectRatio.portrait': 'Retrato',
  'create.aspectRatio.landscape': 'Paisagem',
  'create.video.ratio.placeholder': 'Por favor selecione a proporção do vídeo',
  'create.video.format.placeholder': 'Por favor selecione o formato de saída',
  'create.video.style': 'Estilo de Vídeo',
  'create.video.style.tooltip': 'Selecionar estilo de geração de vídeo',
  'create.video.style.placeholder': 'Por favor selecione o estilo de vídeo',
  'create.video.quality': 'Qualidade de Vídeo',
  'create.video.quality.tooltip': 'Selecionar qualidade de geração de vídeo',
  'create.video.quality.placeholder': 'Por favor selecione a qualidade do vídeo',
  'create.duration.select.placeholder': 'Por favor selecione a duração do vídeo',
  'create.model.select.placeholder': 'Por favor selecione primeiro um modelo',
  'video.not.supported': 'Seu navegador não suporta reprodução de vídeo.',
  // UnderDevelopment Internacionalização
  'underDevelopment.comingSoon': 'Em breve',
  'underDevelopment.title': 'Funcionalidade em desenvolvimento',
  'underDevelopment.subtitle': 'Estamos trabalhando duro para desenvolver esta funcionalidade, fique atento!',
  'underDevelopment.backHome': 'Voltar ao início',
  'underDevelopment.goBack': 'Voltar',
  // UserMenu Internacionalização
  'userMenu.email.notBound': 'Email não vinculado',
  'userMenu.status.verified': 'Verificado',
  'userMenu.status.guest': 'Convidado',
  'userMenu.recharge': 'Recarregar agora',
  'userMenu.community': 'Comunidade',
  'userMenu.group.account': 'Configurações da conta',
  'userMenu.group.assets': 'Ativos e pedidos',
  'userMenu.group.workspace': 'Espaço de trabalho',
  'userMenu.group.support': 'Suporte',
  'userMenu.item.profile': 'Perfil',
  'userMenu.item.settings': 'Configurações',
  'userMenu.item.security': 'Segurança',
  'userMenu.item.privacy': 'Privacidade',
  'userMenu.item.wallet': 'Minha carteira',
  'userMenu.item.subscription': 'Assinatura',
  'userMenu.item.orders': 'Histórico de pedidos',
  'userMenu.item.works': 'Meus trabalhos',
  'userMenu.item.notifications': 'Notificações',
  'userMenu.item.help': 'Central de ajuda',
  'userMenu.item.invite': 'Convidar amigos',
  'userMenu.item.feedback': 'Feedback',
  'userMenu.item.about': 'Sobre nós',
  'userMenu.level': 'Nível',
  'userMenu.member.vip1': 'Membro básico',
  'userMenu.member.vip2': 'Membro prata',
  'userMenu.member.vip3': 'Membro ouro',
  'userMenu.member.vip4': 'Membro diamante',
  'userMenu.member.vip5': 'Membro definitivo',
  'userMenu.logout': 'Sair',
  // Recharge Agreement Internacionalização
  'rechargeAgreement.back': 'Voltar',
  'rechargeAgreement.title': 'Acordo de Serviço de Recarga',
  'rechargeAgreement.lastUpdated': 'Última atualização: ',
  'rechargeAgreement.goRecharge': 'Ir para Recarga',
  'rechargeAgreement.section1.title': 'I. Escopo do Acordo',
  'rechargeAgreement.section1.content1': 'Este acordo é um acordo legal entre você e a plataforma sobre serviços de recarga. Antes de usar o serviço de recarga, leia cuidadosamente todo o conteúdo deste acordo. Se você não concordar com qualquer conteúdo deste acordo, ou não puder entender com precisão o significado dos termos relevantes, não execute operações de recarga.',
  'rechargeAgreement.section1.content2': 'Ao clicar em "Concordar" ou executar operações de recarga, você indica que leu, entendeu e aceitou todo o conteúdo deste acordo.',
  'rechargeAgreement.section2.title': 'II. Instruções de Recarga',
  'rechargeAgreement.section2.subtitle1': '2.1 Métodos de Recarga',
  'rechargeAgreement.section2.content1': 'A plataforma suporta os seguintes métodos de recarga:',
  'rechargeAgreement.section2.method1': 'Alipay',
  'rechargeAgreement.section2.method2': 'WeChat Pay',
  'rechargeAgreement.section2.method3': 'Cartão Bancário (UnionPay, Visa, MasterCard)',
  'rechargeAgreement.section2.method4': 'Criptomoeda USDT (ERC20/TRC20)',
  'rechargeAgreement.section2.subtitle2': '2.2 Moeda de Recarga',
  'rechargeAgreement.section2.content2': 'A plataforma suporta recarga nas seguintes moedas: CNY, USD, USDT. Pode haver conversão de taxa de câmbio entre diferentes moedas, e a taxa de câmbio específica está sujeita à taxa de câmbio em tempo real no momento da recarga.',
  'rechargeAgreement.section2.subtitle3': '2.3 Limites de Recarga',
  'rechargeAgreement.section2.limit1': 'Recarga mínima única: 1 yuan (ou equivalente em outras moedas)',
  'rechargeAgreement.section2.limit2': 'Recarga máxima única: 50.000 yuans (ou equivalente em outras moedas)',
  'rechargeAgreement.section2.limit3': 'Limite de recarga acumulada diária: 100.000 yuans (ou equivalente em outras moedas)',
  'rechargeAgreement.section2.note': 'Nota: Os limites de recarga podem variar dependendo do método de pagamento, nível da conta e outros fatores. Consulte a página de recarga para detalhes.',
  'rechargeAgreement.section3.title': 'III. Chegada da Recarga',
  'rechargeAgreement.section3.subtitle1': '3.1 Tempo de Chegada',
  'rechargeAgreement.section3.time1': 'Alipay, WeChat Pay: Chegada em tempo real',
  'rechargeAgreement.section3.time2': 'Cartão Bancário: 1-3 dias úteis',
  'rechargeAgreement.section3.time3': 'USDT: De acordo com o tempo de confirmação da blockchain, geralmente 10-30 minutos',
  'rechargeAgreement.section3.subtitle2': '3.2 Tratamento de Exceções',
  'rechargeAgreement.section3.content1': 'Se a recarga não chegar a tempo, mantenha o comprovante de pagamento e entre em contato com o atendimento ao cliente imediatamente. A plataforma processará seu problema de recarga o mais rápido possível após verificação.',
  'rechargeAgreement.section4.title': 'IV. Política de Reembolso',
  'rechargeAgreement.section4.important': 'Importante: Após uma recarga bem-sucedida, o saldo da conta não suporta reembolso direto. O saldo só pode ser usado para consumo de serviços dentro da plataforma.',
  'rechargeAgreement.section4.subtitle1': '4.1 Condições de Reembolso',
  'rechargeAgreement.section4.content1': 'Você pode solicitar um reembolso nos seguintes casos:',
  'rechargeAgreement.section4.refund1': 'Recarga duplicada devido a falhas do sistema da plataforma',
  'rechargeAgreement.section4.refund2': 'Serviço indisponível devido a razões da plataforma, e o saldo da conta não foi consumido',
  'rechargeAgreement.section4.refund3': 'Outras circunstâncias especiais aprovadas pela plataforma após revisão',
  'rechargeAgreement.section4.subtitle2': '4.2 Processo de Reembolso',
  'rechargeAgreement.section4.process1': 'Enviar solicitação de reembolso e explicar o motivo',
  'rechargeAgreement.section4.process2': 'Revisão da plataforma (geralmente 3-7 dias úteis)',
  'rechargeAgreement.section4.process3': 'Após aprovação, o reembolso será retornado à sua conta de pagamento',
  'rechargeAgreement.section5.title': 'V. Segurança da Conta',
  'rechargeAgreement.section5.content1': 'Você é responsável por manter adequadamente as informações da conta e a senha. A plataforma não é responsável por perdas causadas por roubo de conta ou vazamento de senha devido às suas próprias razões.',
  'rechargeAgreement.section5.content2': 'Se você encontrar anomalias na conta, entre em contato com o atendimento ao cliente imediatamente e altere a senha. A plataforma ajudará você a lidar com problemas relacionados.',
  'rechargeAgreement.section6.title': 'VI. Isenção de Responsabilidade',
  'rechargeAgreement.section6.disclaimer1': 'A plataforma não é responsável por interrupções de serviço causadas por força maior (como desastres naturais, guerra, ações governamentais, etc.)',
  'rechargeAgreement.section6.disclaimer2': 'Para problemas de recarga causados por falhas de plataformas de pagamento de terceiros, a plataforma ajudará no tratamento, mas não assume responsabilidade direta',
  'rechargeAgreement.section6.disclaimer3': 'Perdas causadas por violações do usuário deste acordo ou leis e regulamentos relevantes serão suportadas pelo próprio usuário',
  'rechargeAgreement.section7.title': 'VII. Modificação do Acordo',
  'rechargeAgreement.section7.content1': 'A plataforma tem o direito de modificar este acordo de acordo com as necessidades de desenvolvimento comercial. Após a modificação do acordo, será anunciado em um local proeminente na plataforma. Se você continuar usando o serviço de recarga, é considerado como aceitação do acordo modificado.',
  'rechargeAgreement.section8.title': 'VIII. Informações de Contato',
  'rechargeAgreement.section8.content1': 'Se você tiver alguma dúvida sobre este acordo, ou precisar solicitar um reembolso ou lidar com problemas de recarga, entre em contato conosco através dos seguintes métodos:',
  'rechargeAgreement.section8.contact1': 'Email de Atendimento ao Cliente: support@example.com',
  'rechargeAgreement.section8.contact2': 'Atendimento ao Cliente Online: Dias úteis 9:00-18:00',
  'rechargeAgreement.section8.contact3': 'Central de Ajuda: Ver Perguntas Frequentes',
  // Internacionalização de perfil
  'profile.editProfile': 'Editar Perfil',
  'profile.creditScore': 'Pontuação de Crédito',
  'profile.level': 'Nível',
  'profile.balance': 'Saldo',
  'profile.tab.basic': 'Informações Básicas',
  'profile.tab.account': 'Ativos da Conta',
  'profile.section.personal': 'Informações Pessoais',
  'profile.section.contact': 'Contato',
  'profile.section.wallet': 'Carteira USDT',
  'profile.label.username': 'Nome de Usuário',
  'profile.label.realName': 'Nome Real',
  'profile.label.accountStatus': 'Status da Conta',
  'profile.label.phone': 'Número de Telefone',
  'profile.label.email': 'Email',
  'profile.label.registerTime': 'Hora de Registro',
  'profile.label.availableBalance': 'Saldo Disponível',
  'profile.label.frozenAmount': 'Valor Congelado',
  'profile.value.notVerified': 'Não Verificado',
  'profile.value.notBound': 'Não Vinculado',
  'profile.value.noAddress': 'Sem Endereço TRC20',
  'profile.value.noDescription': 'Esta pessoa é preguiçosa e não escreveu nada',
  'profile.status.normal': 'Normal',
  'profile.status.disabled': 'Desativado',
  'profile.tooltip.verified': 'Verificado',
  'profile.tooltip.unverified': 'Verificar Agora',
  'profile.banner.construction': 'Esta página está em construção...',
  'profile.modal.title': 'Editar Perfil',
  'profile.modal.cancel': 'Cancelar',
  'profile.modal.save': 'Salvar Alterações',
  'profile.modal.avatarSection': 'Configurações de Avatar',
  'profile.modal.basicSection': 'Informações Básicas',
  'profile.modal.contactSection': 'Informações de Contato',
  'profile.modal.changeAvatar': 'Alterar Avatar',
  'profile.modal.avatarHint': 'Suporta formatos JPG, PNG, máximo 2MB',
  'profile.modal.nickname': 'Apelido',
  'profile.modal.nicknamePlaceholder': 'Digite seu apelido',
  'profile.modal.description': 'Biografia',
  'profile.modal.descriptionPlaceholder': 'Apresente-se em uma frase...',
  'profile.modal.phone': 'Telefone',
  'profile.modal.email': 'Email',
  'profile.message.avatarSizeLimit': 'O tamanho da imagem não pode exceder 2MB',
  'profile.message.avatarUploadSuccess': 'Avatar enviado com sucesso',
  'profile.message.saveSuccess': 'Salvo com sucesso',
  'profile.message.saveFailed': 'Falha ao salvar',
  'profile.message.uploadAvatarFailed': 'Falha ao enviar avatar',
  'profile.message.operationFailed': 'Operação falhou',
  'privacyPreferences.title': 'Preferências de Privacidade',
  'privacyPreferences.description': 'Gerencie suas configurações de privacidade e controle como coletamos e usamos seus dados',
  'privacyPreferences.back': 'Voltar',
  'privacyPreferences.save': 'Salvar Configurações',
  'privacyPreferences.saveSuccess': 'Preferências de privacidade salvas com sucesso',
  'privacyPreferences.saveError': 'Falha ao salvar, tente novamente mais tarde',
  'privacyPreferences.required': 'Obrigatório',
  'privacyPreferences.info': 'Suas preferências de privacidade serão salvas localmente e aplicadas automaticamente em sua próxima visita. Faça login para sincronizar as configurações com a nuvem.',
  'privacyPreferences.info.loggedIn': 'Suas preferências de privacidade serão salvas em sua conta e sincronizadas em todos os dispositivos. Você pode retornar a esta página para modificar essas configurações a qualquer momento.',
  'cookieBanner.message': 'Usamos cookies e armazenamento local para login, tema e funcionalidades básicas. Ao continuar você concorda com nossa política de privacidade.',
  'cookieBanner.acceptAll': 'Aceitar tudo',
  'cookieBanner.essentialOnly': 'Apenas essenciais',
  'cookieBanner.settings': 'Preferências',
  'privacyPreferences.cookies.title': 'Preferências de Cookies',
  'privacyPreferences.cookies.description': 'Os cookies nos ajudam a fornecer uma melhor experiência de serviço. Você pode escolher aceitar ou rejeitar certos tipos de cookies.',
  'privacyPreferences.cookies.essential': 'Cookies Essenciais',
  'privacyPreferences.cookies.essential.desc': 'Estes cookies são necessários para o funcionamento adequado do site e não podem ser desativados. Eles são geralmente usados para segurança, login e funcionalidade básica.',
  'privacyPreferences.cookies.functional': 'Cookies Funcionais',
  'privacyPreferences.cookies.functional.desc': 'Estes cookies permitem que o site lembre suas escolhas e forneça funcionalidade aprimorada e experiência personalizada.',
  'privacyPreferences.cookies.analytics': 'Cookies de Análise',
  'privacyPreferences.cookies.analytics.desc': 'Estes cookies nos ajudam a entender como os visitantes usam o site para que possamos melhorar nossos serviços.',
  'privacyPreferences.cookies.marketing': 'Cookies de Marketing',
  'privacyPreferences.cookies.marketing.desc': 'Estes cookies são usados para rastrear sua atividade de navegação para mostrar anúncios e conteúdo relevantes.',
  'privacyPreferences.data.title': 'Preferências de Coleta de Dados',
  'privacyPreferences.data.description': 'Controle como coletamos e usamos seus dados para melhorar a experiência do serviço.',
  'privacyPreferences.data.collection': 'Coleta de Dados',
  'privacyPreferences.data.collection.desc': 'Permita-nos coletar os dados de uso necessários para fornecer e melhorar os serviços.',
  'privacyPreferences.data.analytics': 'Análise de Dados',
  'privacyPreferences.data.analytics.desc': 'Permita-nos analisar seus padrões de uso para otimizar o desempenho do serviço e a experiência do usuário.',
  'privacyPreferences.data.personalization': 'Personalização',
  'privacyPreferences.data.personalization.desc': 'Permita-nos fornecer conteúdo e recomendações personalizados com base em suas preferências e hábitos de uso.',
  'privacyPreferences.marketing.title': 'Preferências de Marketing',
  'privacyPreferences.marketing.description': 'Escolha os tipos de comunicações de marketing que deseja receber.',
  'privacyPreferences.marketing.emails': 'E-mails de Marketing',
  'privacyPreferences.marketing.emails.desc': 'Receba notificações por e-mail sobre atualizações de produtos, promoções e ofertas especiais.',
  'privacyPreferences.marketing.sms': 'SMS de Marketing',
  'privacyPreferences.marketing.sms.desc': 'Receba notificações SMS sobre atualizações importantes e promoções.',
  'privacyPreferences.marketing.push': 'Notificações Push',
  'privacyPreferences.marketing.push.desc': 'Receba notificações push do navegador, incluindo atualizações de produtos e mensagens importantes.',
  'privacyPreferences.thirdParty.title': 'Compartilhamento de Dados com Terceiros',
  'privacyPreferences.thirdParty.description': 'Controle se permite o compartilhamento de seus dados com provedores de serviços terceirizados.',
  'privacyPreferences.thirdParty.sharing': 'Compartilhamento de Dados com Terceiros',
  'privacyPreferences.thirdParty.sharing.desc': 'Permita-nos compartilhar dados de uso anonimizados com provedores de serviços terceirizados confiáveis para melhorar os serviços.',
  
  // Política de Privacidade
  'privacyPolicy.title': 'Política de Privacidade',
  'privacyPolicy.lastUpdated': 'Última atualização: {date}',
  'privacyPolicy.intro1': 'Esta Política de Privacidade descreve como a plataforma AIMATEX (doravante "nós" ou "esta plataforma") coleta, usa, armazena e protege suas informações pessoais quando você usa nossos serviços, bem como seus direitos de privacidade. Valorizamos muito a proteção de sua privacidade. Por favor, leia atentamente esta Política de Privacidade.',
  'privacyPolicy.intro2': 'Ao usar nossos serviços, você concorda com esta Política de Privacidade. Se você não concorda com qualquer parte desta Política de Privacidade, por favor não use nossos serviços.',
  'privacyPolicy.section1.title': 'I. Informações que Coletamos',
  'privacyPolicy.section1.1.title': '1.1 Informações que Você Fornece',
  'privacyPolicy.section1.1.intro': 'Ao usar este serviço, você pode precisar fornecer as seguintes informações:',
  'privacyPolicy.section1.1.item1.label': 'Informações da Conta',
  'privacyPolicy.section1.1.item1.desc': 'Nome de usuário, endereço de e-mail, senha, número de telefone, etc.',
  'privacyPolicy.section1.1.item2.label': 'Informações do Perfil',
  'privacyPolicy.section1.1.item2.desc': 'Avatar, apelido, biografia, etc. (opcional)',
  'privacyPolicy.section1.1.item3.label': 'Informações de Pagamento',
  'privacyPolicy.section1.1.item3.desc': 'Métodos de pagamento, endereço de cobrança, etc. (para processar pagamentos)',
  'privacyPolicy.section1.1.item4.label': 'Conteúdo Gerado',
  'privacyPolicy.section1.1.item4.desc': 'Prompts de texto, imagens de referência, vídeos, música, imagens, modelos 3D gerados, etc. que você carrega',
  'privacyPolicy.section1.2.title': '1.2 Informações Coletadas Automaticamente',
  'privacyPolicy.section1.2.intro': 'Quando você usa este serviço, podemos coletar automaticamente as seguintes informações:',
  'privacyPolicy.section1.2.item1.label': 'Informações do Dispositivo',
  'privacyPolicy.section1.2.item1.desc': 'Tipo de dispositivo, sistema operacional, tipo e versão do navegador, identificadores de dispositivo, etc.',
  'privacyPolicy.section1.2.item2.label': 'Dados de Uso',
  'privacyPolicy.section1.2.item2.desc': 'Hora de acesso, páginas visitadas, funcionalidades usadas, registros de operações, etc.',
  'privacyPolicy.section1.2.item3.label': 'Informações de Rede',
  'privacyPolicy.section1.2.item3.desc': 'Endereço IP, tipo de rede, operadora de rede, etc.',
  'privacyPolicy.section1.2.item4.label': 'Informações de Registro',
  'privacyPolicy.section1.2.item4.desc': 'Registros de erros, dados de desempenho, etc.',
  'privacyPolicy.section1.3.title': '1.3 Cookies e Tecnologias Similares',
  'privacyPolicy.section1.3.intro': 'Usamos cookies e tecnologias similares para:',
  'privacyPolicy.section1.3.item1': 'Manter seu status de login',
  'privacyPolicy.section1.3.item2': 'Lembrar suas preferências (como idioma, tema, etc.)',
  'privacyPolicy.section1.3.item3': 'Analisar o uso do serviço para melhorar a qualidade do serviço',
  'privacyPolicy.section1.3.item4': 'Fornecer uma experiência personalizada',
  'privacyPolicy.section1.3.note': 'Você pode recusar cookies através das configurações do navegador, mas isso pode afetar o uso de algumas funcionalidades.',
  'privacyPolicy.section2.title': 'II. Propósito do Uso das Informações',
  'privacyPolicy.section2.intro': 'Coletamos e usamos suas informações para os seguintes propósitos:',
  'privacyPolicy.section2.item1.label': 'Fornecer Serviços',
  'privacyPolicy.section2.item1.desc': 'Processar suas solicitações de geração de conteúdos (vídeos, música, imagens, modelos 3D, etc.), gerenciar sua conta e obras, etc.',
  'privacyPolicy.section2.item2.label': 'Melhorar Serviços',
  'privacyPolicy.section2.item2.desc': 'Analisar o uso, otimizar o desempenho do serviço e a experiência do usuário',
  'privacyPolicy.section2.item3.label': 'Gestão de Conta',
  'privacyPolicy.section2.item3.desc': 'Verificar identidade, processar pagamentos, enviar notificações, etc.',
  'privacyPolicy.section2.item4.label': 'Segurança',
  'privacyPolicy.section2.item4.desc': 'Detectar e prevenir fraudes, abusos, ameaças de segurança, etc.',
  'privacyPolicy.section2.item5.label': 'Suporte ao Cliente',
  'privacyPolicy.section2.item5.desc': 'Responder às suas consultas, processar reclamações e feedback, etc.',
  'privacyPolicy.section2.item6.label': 'Conformidade Legal',
  'privacyPolicy.section2.item6.desc': 'Cumprir requisitos legais, cooperar com investigações das forças da lei, etc.',
  'privacyPolicy.section3.title': 'III. Compartilhamento e Divulgação de Informações',
  'privacyPolicy.section3.1.title': '3.1 Não Vendemos Suas Informações Pessoais',
  'privacyPolicy.section3.1.content': 'Não vendemos, alugamos nem negociamos suas informações pessoais com terceiros.',
  'privacyPolicy.section3.2.title': '3.2 Provedores de Serviços',
  'privacyPolicy.section3.2.intro': 'Podemos compartilhar informações com os seguintes tipos de provedores de serviços:',
  'privacyPolicy.section3.2.item1.label': 'Provedores de Serviços em Nuvem',
  'privacyPolicy.section3.2.item1.desc': 'Para armazenamento e processamento de dados',
  'privacyPolicy.section3.2.item2.label': 'Provedores de Serviços de Pagamento',
  'privacyPolicy.section3.2.item2.desc': 'Para processar transações de pagamento',
  'privacyPolicy.section3.2.item3.label': 'Provedores de Serviços de Análise',
  'privacyPolicy.section3.2.item3.desc': 'Para analisar o uso do serviço',
  'privacyPolicy.section3.2.item4.label': 'Provedores de Serviços de Suporte ao Cliente',
  'privacyPolicy.section3.2.item4.desc': 'Para fornecer suporte ao cliente',
  'privacyPolicy.section3.2.note': 'Esses provedores de serviços só podem usar as informações para nos fornecer serviços e não para outros propósitos.',
  'privacyPolicy.section3.3.title': '3.3 Requisitos Legais',
  'privacyPolicy.section3.3.intro': 'Podemos divulgar suas informações nas seguintes circunstâncias:',
  'privacyPolicy.section3.3.item1': 'Cumprir leis, regulamentos, ordens judiciais ou requisitos governamentais',
  'privacyPolicy.section3.3.item2': 'Proteger nossos direitos, propriedade ou segurança',
  'privacyPolicy.section3.3.item3': 'Prevenir ou investigar possíveis atividades ilegais',
  'privacyPolicy.section3.3.item4': 'Proteger a segurança dos usuários ou do público',
  'privacyPolicy.section3.4.title': '3.4 Transferência de Negócio',
  'privacyPolicy.section3.4.content': 'Se ocorrer uma fusão, aquisição ou transferência de ativos, suas informações podem ser transferidas. Notificaremos você antes da transferência.',
  'privacyPolicy.section4.title': 'IV. Armazenamento e Segurança das Informações',
  'privacyPolicy.section4.1.title': '4.1 Localização de Armazenamento',
  'privacyPolicy.section4.1.content': 'Suas informações podem ser armazenadas em servidores localizados dentro ou fora da República Popular da China. Tomaremos medidas apropriadas para garantir a segurança das informações.',
  'privacyPolicy.section4.2.title': '4.2 Período de Armazenamento',
  'privacyPolicy.section4.2.intro': 'Mantemos suas informações apenas pelo período necessário:',
  'privacyPolicy.section4.2.item1': 'Informações da conta: durante a duração da sua conta e por um período após o cancelamento',
  'privacyPolicy.section4.2.item2': 'Conteúdo gerado: mantido de acordo com suas configurações ou requisitos legais',
  'privacyPolicy.section4.2.item3': 'Dados de uso: geralmente mantidos por um período mais curto para análise e melhoria do serviço',
  'privacyPolicy.section4.3.title': '4.3 Medidas de Segurança',
  'privacyPolicy.section4.3.intro': 'Tomamos as seguintes medidas de segurança para proteger suas informações:',
  'privacyPolicy.section4.3.item1': 'Transmissão e armazenamento criptografados',
  'privacyPolicy.section4.3.item2': 'Controle de acesso e autenticação',
  'privacyPolicy.section4.3.item3': 'Auditorias de segurança regulares e varreduras de vulnerabilidades',
  'privacyPolicy.section4.3.item4': 'Treinamento de funcionários e acordos de confidencialidade',
  'privacyPolicy.section4.3.note': 'Por favor, note que nenhuma medida de segurança é 100% segura. Não podemos garantir segurança absoluta das informações.',
  'privacyPolicy.section5.title': 'V. Seus Direitos',
  'privacyPolicy.section5.intro': 'De acordo com as leis e regulamentos aplicáveis, você tem os seguintes direitos:',
  'privacyPolicy.section5.item1.label': 'Direito de Acesso',
  'privacyPolicy.section5.item1.desc': 'Ver suas informações pessoais que possuímos',
  'privacyPolicy.section5.item2.label': 'Direito de Retificação',
  'privacyPolicy.section5.item2.desc': 'Corrigir informações imprecisas ou incompletas',
  'privacyPolicy.section5.item3.label': 'Direito de Exclusão',
  'privacyPolicy.section5.item3.desc': 'Solicitar a exclusão de suas informações pessoais (exceto quando a lei exigir retenção)',
  'privacyPolicy.section5.item4.label': 'Direito de Retirar Consentimento',
  'privacyPolicy.section5.item4.desc': 'Retirar seu consentimento para o processamento de informações',
  'privacyPolicy.section5.item5.label': 'Direito à Portabilidade de Dados',
  'privacyPolicy.section5.item5.desc': 'Obter uma cópia de suas informações pessoais',
  'privacyPolicy.section5.item6.label': 'Direito de Oposição',
  'privacyPolicy.section5.item6.desc': 'Opor-se a certas atividades de processamento de informações',
  'privacyPolicy.section5.note': 'Para exercer os direitos acima, entre em contato conosco através das informações de contato no final desta Política de Privacidade.',
  'privacyPolicy.section6.title': 'VI. Proteção de Menores',
  'privacyPolicy.section6.content1': 'Este serviço é principalmente destinado a usuários com mais de 18 anos. Se você tiver menos de 18 anos, use este serviço com o consentimento e sob a supervisão do seu tutor.',
  'privacyPolicy.section6.content2': 'Se descobrirmos que coletamos informações pessoais de usuários com menos de 18 anos sem o consentimento do tutor, excluiremos as informações relevantes o mais rápido possível.',
  'privacyPolicy.section7.title': 'VII. Links de Terceiros',
  'privacyPolicy.section7.content': 'Este serviço pode conter links para sites de terceiros. Não somos responsáveis pelas práticas de privacidade desses sites de terceiros. Ao visitar esses sites, revise suas políticas de privacidade.',
  'privacyPolicy.section8.title': 'VIII. Alterações na Política de Privacidade',
  'privacyPolicy.section8.content1': 'Podemos atualizar esta Política de Privacidade de tempos em tempos. Mudanças importantes serão notificadas a você pelo menos 30 dias antes de entrarem em vigor. O uso contínuo do serviço indica sua aceitação da Política de Privacidade atualizada.',
  'privacyPolicy.section8.content2': 'Atualizaremos a data "Última atualização" no topo desta página e informaremos você sobre mudanças importantes por e-mail ou notificações no aplicativo.',
  'privacyPolicy.section9.title': 'IX. Entre em Contato',
  'privacyPolicy.section9.intro': 'Se você tiver perguntas, comentários ou reclamações sobre esta Política de Privacidade, entre em contato conosco através dos seguintes métodos:',
  'privacyPolicy.section9.email': 'E-mail: {email}',
  'privacyPolicy.section9.hours': 'Horário de atendimento ao cliente: dias úteis 9:00-18:00',
  'privacyPolicy.section9.response': 'Responderemos à sua solicitação dentro de um tempo razoável.',
  
  // Termos de Serviço
  'termsOfService.title': 'Termos de Serviço',
  'termsOfService.lastUpdated': 'Última atualização: {date}',
  'termsOfService.intro': 'Antes de usar nossos serviços, leia atentamente estes Termos de Serviço. Ao acessar ou usar a plataforma AIMATEX (doravante "esta plataforma" ou "serviço"), você concorda em estar vinculado a estes Termos de Serviço. Se você não concorda com qualquer parte destes Termos de Serviço, por favor não use nossos serviços.',
  'termsOfService.section1.title': 'I. Definições e Interpretação',
  'termsOfService.section1.1.title': '1.1 Definições',
  'termsOfService.section1.1.intro': 'Nestes Termos de Serviço, a menos que o contexto indique o contrário, os seguintes termos têm os seguintes significados:',
  'termsOfService.section1.1.item1.label': '"Plataforma" ou "Esta Plataforma"',
  'termsOfService.section1.1.item1.desc': 'Refere-se à plataforma de serviço de geração de vídeo AIMATEX, incluindo mas não limitado a sites, aplicativos móveis e serviços relacionados.',
  'termsOfService.section1.1.item2.label': '"Nós", "Nosso", "Empresa"',
  'termsOfService.section1.1.item2.desc': 'Refere-se ao operador da plataforma AIMATEX, ou seja, ProTX Team.',
  'termsOfService.section1.1.item3.label': '"Você", "Usuário"',
  'termsOfService.section1.1.item3.desc': 'Refere-se a qualquer indivíduo, empresa ou outra entidade legal que acessa ou usa este serviço.',
  'termsOfService.section1.1.item4.label': '"Serviço"',
  'termsOfService.section1.1.item4.desc': 'Refere-se a todas as funcionalidades e serviços fornecidos por esta plataforma, incluindo mas não limitado a geração de vídeo, música, imagens, modelos 3D IA e outros conteúdos, seleção de modelos, gestão de obras, gestão de contas de usuário, etc.',
  'termsOfService.section1.1.item5.label': '"Conteúdo"',
  'termsOfService.section1.1.item5.desc': 'Refere-se a qualquer texto, imagem, vídeo, áudio e outros materiais carregados, gerados, criados ou compartilhados por usuários através desta plataforma.',
  'termsOfService.section1.1.item6.label': '"Conteúdo Gerado"',
  'termsOfService.section1.1.item6.desc': 'Refere-se a vídeos, música, imagens, modelos 3D e outras obras geradas por usuários usando os modelos IA desta plataforma.',
  'termsOfService.section1.1.item7.label': '"Conta"',
  'termsOfService.section1.1.item7.desc': 'Refere-se à conta de usuário registrada por usuários nesta plataforma.',
  'termsOfService.section2.title': 'II. Descrição do Serviço',
  'termsOfService.section2.1.title': '2.1 Conteúdo do Serviço',
  'termsOfService.section2.1.intro': 'Esta plataforma fornece serviços abrangentes de geração de conteúdos IA, incluindo mas não limitado a:',
  'termsOfService.section2.1.item1': 'Geração de texto para mídia (vídeos, música, imagens, modelos 3D, etc.) (Text-to-Media)',
  'termsOfService.section2.1.item2': 'Geração de imagem para mídia (vídeos, modelos 3D, etc.) (Image-to-Media)',
  'termsOfService.section2.1.item3': 'Gestão e exibição de diversas obras geradas',
  'termsOfService.section2.1.item4': 'Seleção e gestão de modelos',
  'termsOfService.section2.1.item5': 'Contas de usuário e centro pessoal',
  'termsOfService.section2.1.item6': 'Serviços de assinatura e pagamento',
  'termsOfService.section2.2.title': '2.2 Alterações no Serviço',
  'termsOfService.section2.2.content': 'Reservamo-nos o direito de modificar, suspender ou encerrar parte ou todo o serviço a qualquer momento sem aviso prévio. Não somos responsáveis por quaisquer perdas causadas por alterações no serviço.',
  'termsOfService.section3.title': 'III. Contas de Usuário',
  'termsOfService.section3.1.title': '3.1 Registro de Conta',
  'termsOfService.section3.1.intro': 'O uso deste serviço requer registro de conta. Ao se registrar, você concorda em:',
  'termsOfService.section3.1.item1': 'Fornecer informações de registro verdadeiras, precisas e completas',
  'termsOfService.section3.1.item2': 'Atualizar informações de registro de forma oportuna para mantê-las verdadeiras, precisas e completas',
  'termsOfService.section3.1.item3': 'Ser responsável por todas as atividades sob sua conta',
  'termsOfService.section3.1.item4': 'Manter sua senha de conta segura e não transferir, vender ou emprestar sua conta a outros',
  'termsOfService.section3.2.title': '3.2 Restrição de Idade',
  'termsOfService.section3.2.content': 'Você deve ter pelo menos 18 anos para usar este serviço. Se você tiver menos de 18 anos, use este serviço com o consentimento e sob a supervisão do seu tutor.',
  'termsOfService.section3.3.title': '3.3 Segurança da Conta',
  'termsOfService.section3.3.content': 'Você é responsável por manter a segurança da sua conta. Se descobrir que sua conta foi comprometida ou existe uma vulnerabilidade de segurança, notifique-nos imediatamente. Não somos responsáveis por perdas causadas por sua falha em proteger adequadamente as informações da sua conta.',
  'termsOfService.section4.title': 'IV. Regras de Uso',
  'termsOfService.section4.1.title': '4.1 Atividades Proibidas',
  'termsOfService.section4.1.intro': 'Ao usar este serviço, você não deve:',
  'termsOfService.section4.1.item1': 'Gerar, carregar ou compartilhar conteúdo ilegal, prejudicial, ameaçador, abusivo, assediador, difamatório, vulgar, obsceno, que invada a privacidade ou direitos de propriedade intelectual de outros',
  'termsOfService.section4.1.item2': 'Gerar ou disseminar informações falsas, conteúdo enganoso ou malicioso',
  'termsOfService.section4.1.item3': 'Usar este serviço para fraude comercial, lavagem de dinheiro ou outras atividades ilegais',
  'termsOfService.section4.1.item4': 'Interferir ou destruir o funcionamento normal desta plataforma, incluindo mas não limitado ao uso de ferramentas automatizadas, rastreadores, vírus, etc.',
  'termsOfService.section4.1.item5': 'Acessar sem autorização qualquer sistema, dados ou conta desta plataforma',
  'termsOfService.section4.1.item6': 'Copiar, modificar, distribuir, vender ou alugar qualquer parte desta plataforma',
  'termsOfService.section4.1.item7': 'Fazer engenharia reversa, descompilar ou desmontar qualquer software desta plataforma',
  'termsOfService.section4.2.title': '4.2 Responsabilidade do Conteúdo',
  'termsOfService.section4.2.content': 'Você é totalmente responsável por todo o conteúdo gerado, carregado ou compartilhado através desta plataforma. Não pré-revisamos o conteúdo gerado por usuários, mas nos reservamos o direito de excluir conteúdo que viole as regras a qualquer momento.',
  'termsOfService.section5.title': 'V. Propriedade Intelectual',
  'termsOfService.section5.1.title': '5.1 Propriedade Intelectual da Plataforma',
  'termsOfService.section5.1.content': 'Todos os direitos de propriedade intelectual desta plataforma, incluindo mas não limitado a marcas, patentes, direitos autorais, segredos comerciais, etc., pertencem a nós ou aos titulares de direitos correspondentes. Você não pode usá-los sem autorização.',
  'termsOfService.section5.2.title': '5.2 Conteúdo Gerado pelo Usuário',
  'termsOfService.section5.2.content': 'Os direitos de propriedade intelectual do conteúdo que você gera através desta plataforma pertencem a você. No entanto, você nos concede um direito não exclusivo, mundial, gratuito e sublicenciável de usar, exibir e distribuir seu conteúdo para fornecer e melhorar serviços.',
  'termsOfService.section5.3.title': '5.3 Modelos IA',
  'termsOfService.section5.3.content': 'Os direitos de propriedade intelectual dos modelos IA (incluindo modelos Sora) usados por esta plataforma pertencem aos seus desenvolvedores. Você não pode copiar, modificar ou distribuir esses modelos.',
  'termsOfService.section6.title': 'VI. Serviços Pagos',
  'termsOfService.section6.1.title': '6.1 Modelos de Pagamento',
  'termsOfService.section6.1.content': 'Esta plataforma oferece dois modelos de pagamento: assinatura e pagamento por uso. Preços específicos e métodos de cobrança estão sujeitos aos anúncios da plataforma.',
  'termsOfService.section6.2.title': '6.2 Pagamento',
  'termsOfService.section6.2.content': 'Você concorda em pagar as taxas de serviço de acordo com os preços anunciados pela plataforma. Todas as taxas são calculadas em RMB ou outras moedas suportadas pela plataforma. Após um pagamento bem-sucedido, as taxas não são reembolsáveis, a menos que a lei disponha o contrário ou tenhamos feito outros compromissos.',
  'termsOfService.section6.3.title': '6.3 Política de Reembolso',
  'termsOfService.section6.3.content': 'A menos que a lei disponha o contrário ou tenhamos feito outros compromissos, as taxas pagas não são reembolsáveis. Se o serviço não puder ser usado normalmente devido a problemas da plataforma, forneceremos reembolsos ou compensações de acordo com a situação real.',
  'termsOfService.section7.title': 'VII. Disponibilidade do Serviço',
  'termsOfService.section7.1.title': '7.1 Interrupção do Serviço',
  'termsOfService.section7.1.intro': 'Não somos responsáveis por interrupções de serviço causadas pelas seguintes razões:',
  'termsOfService.section7.1.item1': 'Manutenção, atualização ou falha do sistema',
  'termsOfService.section7.1.item2': 'Fatores de força maior (como desastres naturais, guerras, greves, etc.)',
  'termsOfService.section7.1.item3': 'Problemas com provedores de serviços de terceiros',
  'termsOfService.section7.1.item4': 'Falhas de rede ou problemas com dispositivos do usuário',
  'termsOfService.section7.2.title': '7.2 Garantia do Serviço',
  'termsOfService.section7.2.content': 'Nos esforçamos para garantir a estabilidade e disponibilidade do serviço, mas não garantimos que o serviço não será interrompido, sem erros ou completamente seguro. O serviço é fornecido "como está" e "conforme disponível" sem garantias expressas ou implícitas.',
  'termsOfService.section8.title': 'VIII. Proteção de Privacidade',
  'termsOfService.section8.content': 'Valorizamos a proteção de sua privacidade. Para obter informações sobre como coletamos, usamos e protegemos suas informações pessoais, consulte nossa Política de Privacidade. O uso deste serviço indica seu acordo com nossa Política de Privacidade.',
  'termsOfService.section9.title': 'IX. Limitação de Responsabilidade',
  'termsOfService.section9.1.title': '9.1 Escopo de Responsabilidade',
  'termsOfService.section9.1.intro': 'Na medida máxima permitida por lei, não somos responsáveis por quaisquer danos diretos, indiretos, incidentais, especiais ou consequenciais resultantes do uso ou impossibilidade de usar este serviço, incluindo mas não limitado a:',
  'termsOfService.section9.1.item1': 'Perda de lucros, perda de dados ou outras perdas econômicas',
  'termsOfService.section9.1.item2': 'Interrupção de negócios',
  'termsOfService.section9.1.item3': 'Lesão corporal ou perda de propriedade',
  'termsOfService.section9.1.item4': 'Violação de privacidade',
  'termsOfService.section9.2.title': '9.2 Limite de Responsabilidade',
  'termsOfService.section9.2.content': 'Nossa responsabilidade total não excede o valor total que você realmente pagou por este serviço nos últimos 12 meses, ou $100 (o valor mais alto).',
  'termsOfService.section10.title': 'X. Rescisão do Serviço',
  'termsOfService.section10.1.title': '10.1 Rescisão pelo Usuário',
  'termsOfService.section10.1.content': 'Você pode parar de usar este serviço e cancelar sua conta a qualquer momento.',
  'termsOfService.section10.2.title': '10.2 Rescisão pela Plataforma',
  'termsOfService.section10.2.intro': 'Temos o direito de rescindir ou suspender imediatamente sua conta e serviço nas seguintes circunstâncias:',
  'termsOfService.section10.2.item1': 'Você viola estes Termos de Serviço',
  'termsOfService.section10.2.item2': 'Você se envolve em atividades ilegais',
  'termsOfService.section10.2.item3': 'Sua conta não foi usada por um longo período',
  'termsOfService.section10.2.item4': 'Requisitos legais ou regulatórios',
  'termsOfService.section10.2.note': 'Após a rescisão do serviço, você não poderá mais acessar sua conta e conteúdo gerado, a menos que a lei disponha o contrário.',
  'termsOfService.section11.title': 'XI. Resolução de Disputas',
  'termsOfService.section11.1.title': '11.1 Negociação',
  'termsOfService.section11.1.content': 'Se ocorrer uma disputa, ambas as partes devem primeiro tentar resolvê-la através de negociação amigável.',
  'termsOfService.section11.2.title': '11.2 Lei Aplicável',
  'termsOfService.section11.2.content': 'Estes Termos de Serviço são regidos pelas leis da República Popular da China. Se ambas as partes não puderem resolver a disputa através de negociação, será submetida a um tribunal popular com jurisdição em nossa localidade.',
  'termsOfService.section12.title': 'XII. Outras Disposições',
  'termsOfService.section12.1.title': '12.1 Modificação dos Termos',
  'termsOfService.section12.1.content': 'Reservamo-nos o direito de modificar estes Termos de Serviço a qualquer momento. Mudanças importantes serão notificadas a você pelo menos 30 dias antes de entrarem em vigor. O uso contínuo do serviço indica sua aceitação dos termos modificados.',
  'termsOfService.section12.2.title': '12.2 Divisibilidade',
  'termsOfService.section12.2.content': 'Se alguma disposição destes Termos de Serviço for considerada inválida ou inexequível, isso não afeta a validade das outras disposições.',
  'termsOfService.section12.3.title': '12.3 Acordo Completo',
  'termsOfService.section12.3.content': 'Estes Termos de Serviço constituem o acordo completo entre você e nós com relação ao uso deste serviço, substituindo todos os acordos orais ou escritos anteriores.',
  'termsOfService.section13.title': 'XIII. Entre em Contato',
  'termsOfService.section13.intro': 'Se você tiver perguntas sobre estes Termos de Serviço, entre em contato conosco através dos seguintes métodos:',
  'termsOfService.section13.email': 'E-mail: {email}',
  'termsOfService.section13.hours': 'Horário de atendimento ao cliente: dias úteis 9:00-18:00',
  
  // Footer
  'footer.brand.description': 'Fornece serviços de geração com IA.',
  'footer.joinUs': 'Junte-se a nós',
  'footer.product.title': 'Produto',
  'footer.product.signup': 'Registrar',
  'footer.product.login': 'Entrar',
  'footer.product.workspace': 'Espaço de trabalho',
  'footer.product.works': 'Meus trabalhos',
  'footer.support.title': 'Suporte',
  'footer.support.help': 'Central de ajuda',
  'footer.support.about': 'Sobre nós',
  'footer.support.feedback': 'Feedback',
  'footer.support.contact': 'Entre em contato',
  'footer.legal.title': 'Legal',
  'footer.legal.privacy': 'Política de privacidade',
  'footer.legal.terms': 'Termos de serviço',
  'footer.legal.recharge': 'Acordo de recarga',
  'footer.resources.title': 'Recursos',
  'footer.resources.invite': 'Convidar amigos',
  'footer.resources.account': 'Gerenciamento de conta',
  'footer.resources.orders': 'Central de pedidos',
  'footer.copyright': '© {year} {brand}. Todos os direitos reservados.',
  'footer.description': 'Esta plataforma fornece serviços de geração com IA',
  'footer.openRobotX.title': 'Open Robot X',
  'footer.openRobotX.description': 'Base de dados global de robótica humanoide com comparação de especificações e informações da indústria',
  'footer.openRobotX.visit': 'Visitar Open Robot X',
  'footer.ai2obj.title': 'ai2obj',
  'footer.ai2obj.description': 'Plataforma abrangente de geração com IA para criar diversos conteúdos digitais',
  'footer.aimatexMusic.title': 'AIMATEX-MUSIC',
  'footer.aimatexMusic.description': 'Música na nuvem: descobrir, playlists, a tocar e biblioteca',
  
  // Página de preços
  'pricing.title': 'Escolha o plano que funciona para você',
  'pricing.plan.basic.sub': 'Básico',
  'pricing.plan.pro.sub': 'Pro',
  'pricing.plan.team.sub': 'Equipe',
  'pricing.plan.popular': 'POPULAR',
  'pricing.plan.button.select': 'Selecionar plano',
  'pricing.plan.button.subscribe': 'Assinar agora',
  'pricing.plan.basic.videoQuota': '5/mês',
  'pricing.plan.basic.videoDuration': '6-10s',
  'pricing.plan.basic.videoQuality': '720P',
  'pricing.plan.pro.videoQuota': '30/mês',
  'pricing.plan.pro.videoDuration': '10-15s',
  'pricing.plan.pro.videoQuality': '1080P',
  'pricing.plan.team.videoQuota': '100/mês',
  'pricing.plan.team.videoDuration': '10-15s',
  'pricing.plan.team.videoQuality': '1080P/4K',
  'pricing.feature.videoQuota': 'Cota de geração de vídeo',
  'pricing.feature.videoDuration': 'Duração do vídeo',
  'pricing.feature.videoQuality': 'Qualidade do vídeo',
  'pricing.feature.storyboard': 'Storyboard',
  'pricing.feature.workflow': 'Fluxo de trabalho',
  'pricing.feature.priorityQueue': 'Fila prioritária',
  'pricing.feature.exclusiveChannel': 'Canal exclusivo',
  'pricing.feature.highestQuality': 'Modo de máxima qualidade',
  'pricing.feature.sdImage': 'Geração de imagens SD',
  'pricing.feature.unlimited': 'Ilimitado',
  'pricing.feature.promptOptimization': 'Otimização de prompt',
  'pricing.feature.imageSize': 'Tamanho da imagem',
  'pricing.feature.storage': 'Espaço de armazenamento',
  'pricing.feature.commercialLicense': 'Licença comercial',
  'pricing.feature.apiAccess': 'Acesso à API',
  'pricing.then': 'depois',
  'cta.title': 'Comece a criar seus vídeos',
  'cta.description': 'Cadastre-se agora e transforme sua criatividade em obras de vídeo impressionantes com tecnologia IA',
  'cta.button': 'Começar grátis',
  'technology.coreArchitecture': 'ARQUITETURA CORE',
  'technology.workflowEngine.title': 'Motor de Fluxo de Trabalho Visual',
  'technology.workflowEngine.description': 'Suporte de fluxo de trabalho visual em breve. Cada nó é um controle preciso sobre a criatividade.',
  'technology.node.checkpointLoader': 'Checkpoint Loader',
  'technology.node.clipTextPositive': 'CLIP Text (Positive)',
  'technology.node.clipTextNegative': 'CLIP Text (Negative)',
  'technology.node.ksamplerAdvanced': 'KSampler Advanced',
  'technology.node.vaeDecode': 'VAE Decode',
  'technology.node.previewImage': 'Preview Image',
  'technology.hud.systemResourceMonitor': 'Monitor de Recursos do Sistema',
  'technology.hud.gpuVram': 'GPU VRAM',
  'technology.terminal.console': 'console — zsh',
  'technology.button.runWorkflow': 'Executar Fluxo de Trabalho',
  'technology.button.running': 'Executando...',
  'technology.log.systemInitialized': '> Sistema inicializado.',
  'technology.log.waitingForInput': '> Aguardando entrada do usuário...',
  'technology.log.loadingCheckpoint': 'Loading SDXL Checkpoint (fp16)...',
  'technology.log.tokenizingPrompt': 'Tokenizing positive prompt...',
  'technology.log.ksamplerSteps': 'KSampler: 30/30 steps (Euler A)',
  'technology.log.generationComplete': 'Generation complete.',
  'technology.benchmark.title': 'Benchmark de Desempenho Definitivo',
  'technology.benchmark.description': 'Por esta melhoria de 0,5 segundos, reescrevemos 30% dos operadores subjacentes.',
  'technology.benchmark.fps.title': 'Velocidade de Geração (FPS)',
  'technology.benchmark.fps.subtitle': 'Comparison @ 1080p',
  'technology.benchmark.vram.title': 'Otimização VRAM',
  'technology.benchmark.vram.subtitle': 'Lower is better',
  'technology.benchmark.productX': 'ProductX',
  'technology.benchmark.others': 'Others',
  'technology.benchmark.standard': 'Standard',
  'technology.galaxy.openEcology': 'ECOLOGIA ABERTA',
  'technology.galaxy.title': 'Universo Infinito de Modelos',
  'technology.galaxy.description': 'Suporte para conexão direta Civitai, milhares de modelos, carregamento com um clique.',
  'technology.galaxy.autoSync': 'Auto-Sync',
  
  // Página de feedback
  'feedback.leftPanel.title.line1': 'Nós ouvimos',
  'feedback.leftPanel.title.line2': 'Sua voz',
  'feedback.leftPanel.description': 'Seu feedback é a força motriz por trás da melhoria do nosso produto. Seja você encontrou um bug ou tem uma ideia brilhante para um novo recurso, nos avise.',
  'feedback.contact.helpDoc.title': 'Documentação de ajuda',
  'feedback.contact.helpDoc.desc': 'Navegar por perguntas frequentes e guias do usuário',
  'feedback.contact.email.title': 'Suporte por e-mail',
  'feedback.contact.service.title': 'Suporte online',
  'feedback.contact.service.hours': 'Dias úteis 9:00 - 18:00',
  'feedback.type.suggestion.title': 'Sugestão de recurso',
  'feedback.type.suggestion.desc': 'Tenho novas ideias ou sugestões de melhoria',
  'feedback.type.bug.title': 'Relatório de bug',
  'feedback.type.bug.desc': 'Encontrei um erro ou exceção',
  'feedback.type.question.title': 'Consulta de uso',
  'feedback.type.question.desc': 'Não entendo como usar um recurso',
  'feedback.type.other.title': 'Outro',
  'feedback.type.other.desc': 'Outros tipos de feedback',
  'feedback.form.type.label': 'Tipo de feedback',
  'feedback.form.title.label': 'Resumo breve',
  'feedback.form.title.placeholder': 'Descreva seu problema ou sugestão em uma frase',
  'feedback.form.title.required': 'Por favor, insira um título',
  'feedback.form.content.label': 'Descrição detalhada',
  'feedback.form.content.placeholder': 'Por favor, descreva o contexto, etapas de reprodução ou sugestões específicas...',
  'feedback.form.content.required': 'Por favor, insira conteúdo detalhado',
  'feedback.form.attachment.label': 'Anexos (Opcional)',
  'feedback.upload.dragText': 'Clique ou arraste arquivos aqui para enviar',
  'feedback.upload.hint': 'Suporta formatos JPG, PNG, PDF e outros, tamanho de arquivo único não superior a 5MB',
  'feedback.upload.sizeLimit': 'O tamanho do arquivo não pode exceder 5MB',
  'feedback.form.priority.label': 'Prioridade',
  'feedback.priority.low.label': 'Baixa',
  'feedback.priority.low.desc': 'Não afeta o uso',
  'feedback.priority.medium.label': 'Média',
  'feedback.priority.medium.desc': 'Afeta a experiência do usuário',
  'feedback.priority.high.label': 'Alta',
  'feedback.priority.high.desc': 'Obstaculiza seriamente o uso',
  'feedback.form.contact.label': 'Informações de contato (Opcional)',
  'feedback.form.contact.placeholder': 'E-mail ou número de telefone',
  'feedback.form.submit': 'Enviar feedback',
  'feedback.submit.error': 'Falha no envio, tente novamente mais tarde',
  'feedback.success.title': 'Feedback recebido!',
  'feedback.success.description': 'Obrigado pelo seu valioso feedback. Nossa equipe de produto lerá cuidadosamente cada feedback. Se for um relatório de bug, podemos entrar em contato através das informações de contato fornecidas.',
  'feedback.success.back': 'Voltar',
  'feedback.success.another': 'Enviar outro',
  // Página de convite
  'invite.partnerProgram': 'Programa de Parceiros',
  'invite.title.line1': 'Convide amigos',
  'invite.title.line2': 'Crie valor ilimitado',
  'invite.reward.inviter': 'Ganhe {amount} de recompensa em dinheiro para cada amigo convidado.',
  'invite.reward.invitee': 'Seu amigo recebe {amount} de bônus de boas-vindas ao se registrar.',
  'invite.step1.title': '1. Compartilhe o link',
  'invite.step1.desc': 'Compartilhe seu link exclusivo nas redes sociais',
  'invite.step2.title': '2. Amigo ativa',
  'invite.step2.desc': 'Amigo completa registro e verificação',
  'invite.step3.title': '3. Saque os ganhos',
  'invite.step3.desc': 'Ganhos instantâneos, saque para o saldo',
  'invite.exclusiveCode': 'SEU CÓDIGO EXCLUSIVO',
  'invite.copyCode': 'Copiar código',
  'invite.viewQrcode': 'Ver QR Code',
  'invite.stats.totalInvites': 'Total convidados',
  'invite.stats.availableReward': 'Saldo disponível',
  'invite.stats.totalReward': 'Ganhos totais',
  'invite.withdrawNow': 'Sacar agora',
  'invite.history.title': 'Histórico de convites',
  'invite.filter.all': 'Todos',
  'invite.filter.active': 'Ativos',
  'invite.filter.pending': 'Pendentes',
  'invite.status.credited': 'Creditado',
  'invite.status.pending': 'Pendente',
  'invite.history.empty': 'Sem registros',
  'invite.withdraw.title': 'Sacar ganhos',
  'invite.withdraw.cancel': 'Cancelar',
  'invite.withdraw.confirm': 'Confirmar saque',
  'invite.withdraw.amount': 'Valor do saque',
  'invite.withdraw.note': '* O valor será transferido diretamente para o saldo da sua conta.',
  'invite.withdraw.enterAmount': 'Por favor insira o valor do saque',
  'invite.withdraw.insufficientBalance': 'Saldo insuficiente',
  'invite.withdraw.success': '¥{amount} sacados com sucesso para o saldo',
  'invite.qrcode.title': 'Escaneie para participar',
  'invite.copyLink': 'Copiar link',
  'invite.copy.success': 'Copiado com sucesso',
  // Seção Hero da página inicial
  'home.hero.badge': 'Assistente IA · Companheiro · Parceiro',
  'home.hero.title': 'AIMATEX',
  'home.hero.subtitle': 'Seu Colega de Classe, Alma Gêmea, Companheiro de Equipe',
  'home.hero.description': 'AIMATEX é seu assistente de IA, parceiro de aprendizado e companheiro criativo. Fornecemos soluções de IA abrangentes, tornando a IA seu melhor parceiro no trabalho, estudo e criação. Seja aprendizado em sala de aula, colaboração criativa ou cooperação em equipe, AIMATEX é seu parceiro confiável.',
  'home.hero.cta.signup': 'Começar grátis',
  'home.hero.cta.login': 'Entrar',
  'home.hero.cta.workspace': 'Ir para o espaço de trabalho',
  // Seção de produtos da página inicial
  'home.products.title': 'Nossos Produtos',
  'home.products.subtitle': 'Explore produtos de IA inovadores da AIMATEX, cada produto é seu melhor parceiro em diferentes cenários',
  'home.products.seedance2.name': 'Seedance2',
  'home.products.seedance2.description': 'Parceiro de criação de imagem para vídeo com IA, transformando imagens estáticas em vídeos dinâmicos, dando vida à sua criatividade',
  'home.products.ai2obj.name': 'AI2Obj',
  'home.products.ai2obj.description': 'Plataforma de geração e conversão de objetos 3D alimentada por IA, seu parceiro de criação 3D',
  'home.products.openrobotx.name': 'OpenRobotX',
  'home.products.openrobotx.description': 'Explore empresas globais de robôs humanoides, comparações de parâmetros e insights da indústria, seu parceiro de pesquisa em robótica',
  'home.products.openclaw4j.name': 'OpenClaw4j',
  'home.products.openclaw4j.title': 'OpenClaw4j',
  'home.products.openclaw4j.description': 'Plataforma de agentes autónomos — crie e implemente agentes inteligentes com OpenForgeX.',
  'home.products.openclaw4j.cta': 'Experimentar agente',
  'home.products.aimatexMusic.name': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.title': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.description': 'Espaço de música na nuvem pessoal — descobrir faixas, playlists colaborativas, a tocar agora e biblioteca na nuvem',
  'home.products.aimatexMusic.cta': 'Entrar na Música',
  'home.music.eyebrow': 'Suite AIMATEX',
  'home.music.title': 'AIMATEX-MUSIC',
  'home.music.subtitle': 'O seu espaço de música na nuvem — descobrir, colecionar e ouvir em conjunto.',
  'home.music.feature.discover.title': 'Descobrir',
  'home.music.feature.discover.desc': 'Pesquisar e importar faixas para a biblioteca.',
  'home.music.feature.playlist.title': 'Playlists',
  'home.music.feature.playlist.desc': 'Criar e partilhar playlists colaborativas.',
  'home.music.feature.nowPlaying.title': 'A tocar',
  'home.music.feature.nowPlaying.desc': 'Audição sincronizada, favoritos e histórico.',
  'home.music.feature.cloud.title': 'Biblioteca cloud',
  'home.music.feature.cloud.desc': 'Áudio de alta qualidade na nuvem.',
  'home.music.cta': 'Abrir AIMATEX-MUSIC',
'home.showcase.seedance2.eyebrow': 'Image to Video',
  'home.showcase.seedance2.title': 'Seedance2',
  'home.showcase.seedance2.subtitle': 'Turn still frames into cinematic motion with a next-gen creation engine.',
  'home.showcase.seedance2.f1.title': 'Image to Video',
  'home.showcase.seedance2.f1.desc': 'Upload a photo — AI invents light and motion.',
  'home.showcase.seedance2.f2.title': 'Cinema Quality',
  'home.showcase.seedance2.f2.desc': 'High-res output with stable, crisp detail.',
  'home.showcase.seedance2.f3.title': 'Smart Prompts',
  'home.showcase.seedance2.f3.desc': 'AI polishes rough ideas into film-ready prompts.',
  'home.showcase.seedance2.f4.title': 'Style Switch',
  'home.showcase.seedance2.f4.desc': 'Cyberpunk, oil paint, anime — one click.',
  'home.showcase.seedance2.cta': 'Enter Seedance2',
  'home.showcase.ai2obj.eyebrow': '3D Generation',
  'home.showcase.ai2obj.title': 'AI2Obj',
  'home.showcase.ai2obj.subtitle': 'An AI generation platform that turns ideas into usable digital assets.',
  'home.showcase.ai2obj.f1.title': 'Multimodal',
  'home.showcase.ai2obj.f1.desc': 'From text and images to 3D and content assets.',
  'home.showcase.ai2obj.f2.title': 'Object Convert',
  'home.showcase.ai2obj.f2.desc': 'Structure understanding and format conversion.',
  'home.showcase.ai2obj.f3.title': 'Creator Workflow',
  'home.showcase.ai2obj.f3.desc': 'Pipelines built for product and content teams.',
  'home.showcase.ai2obj.f4.title': 'Cloud Delivery',
  'home.showcase.ai2obj.f4.desc': 'Preview, export, and collaborate in the cloud.',
  'home.showcase.ai2obj.cta': 'Visit AI2Obj',
  'home.showcase.openrobotx.eyebrow': 'Robotics Intel',
  'home.showcase.openrobotx.title': 'OpenRobotX',
  'home.showcase.openrobotx.subtitle': 'Global humanoid robot companies, specs, and industry insights in one place.',
  'home.showcase.openrobotx.f1.title': 'World Map',
  'home.showcase.openrobotx.f1.desc': 'Major humanoid vendors and products covered.',
  'home.showcase.openrobotx.f2.title': 'Spec Compare',
  'home.showcase.openrobotx.f2.desc': 'Clear side-by-side capability and positioning.',
  'home.showcase.openrobotx.f3.title': 'Industry News',
  'home.showcase.openrobotx.f3.desc': 'Funding, launches, and tech movements tracked.',
  'home.showcase.openrobotx.f4.title': 'Research Partner',
  'home.showcase.openrobotx.f4.desc': 'Structured intel for selection and research.',
  'home.showcase.openrobotx.cta': 'Explore OpenRobotX',
  'home.showcase.openclaw4j.eyebrow': 'Autonomous Agents',
  'home.showcase.openclaw4j.title': 'OpenClaw4j',
  'home.showcase.openclaw4j.subtitle': 'Build and deploy intelligent agents with OpenForgeX — make agents run for real.',
  'home.showcase.openclaw4j.f1.title': 'Agent Orchestration',
  'home.showcase.openclaw4j.f1.desc': 'Multi-step planning and execution.',
  'home.showcase.openclaw4j.f2.title': 'Tool Calling',
  'home.showcase.openclaw4j.f2.desc': 'Connect APIs and business systems.',
  'home.showcase.openclaw4j.f3.title': 'Observable Runs',
  'home.showcase.openclaw4j.f3.desc': 'Transparent traces for debug and iteration.',
  'home.showcase.openclaw4j.f4.title': 'One-click Deploy',
  'home.showcase.openclaw4j.f4.desc': 'From prototype to live service fast.',
  'home.showcase.openclaw4j.cta': 'Try Agent',
  'home.products.learnMore': 'Saiba mais',
  // Seção de recursos da página inicial
  'home.features.title': 'Oficina criativa tudo-em-um.',
  'home.features.subtitle': 'Mais do que apenas geração de vídeo, é um empoderamento criativo abrangente.',
  'home.features.aiPrompt.title': 'Não sabe escrever prompts? IA escreve para você',
  'home.features.aiPrompt.description': 'Completamente sem ideias? Deixe a IA escrever para você com um clique. Basta digitar algumas palavras, a IA as aperfeiçoa automaticamente em descrições cinematográficas, 10 segundos para gerar. Quer mudar o estilo? Clique novamente, transforme instantaneamente em cyberpunk/pintura a óleo/anime.',
  'home.features.demo.userInput': 'um gato',
  'home.features.demo.aiResult': 'Um elegante gato persa com pelo longo branco macio e fofo e olhos âmbar, sentado em um peitoril ensolarado. O fundo apresenta um céu azul claro e cortinas brancas flutuantes. 4K ultra HD, iluminação cinematográfica, profundidade de campo, fotografia profissional.',
  'home.features.demo.buttonText': 'Gerar IA',
  'home.features.demo.buttonLoading': 'Gerando',
  'home.features.demo.thinkingText': 'IA está criando✨',
  'home.features.quality.title': 'Qualidade cinematográfica',
  'home.features.quality.description': 'Suporte nativo para saída em resolução 4K, cada quadro é cuidadosamente elaborado.',
  'home.features.imageToVideo.title': 'Imagem para vídeo',
  'home.features.imageToVideo.description': 'Carregue uma imagem estática, a IA compreende a iluminação e a física na cena, gera automaticamente dinâmicas subsequentes, dando vida às fotos.',
  'home.features.multimodal.title': 'Ecossistema multimodal',
  'home.features.multimodal.description': 'Não apenas suporta Stable Diffusion de texto para imagem, mas também integra transferência de estilo Midjourney e síntese de áudio ElevenLabs. Complete todas as criações em um fluxo de trabalho.',
  
  // Seção de comunidade da página inicial
  'home.community.title': 'Explore comunidades criativas de IA',
  'home.community.subtitle': 'Junte-se a milhões de criadores, compartilhe suas obras-primas de IA e obtenha inspiração e feedback',
  'home.community.hot': 'Popular',
  'home.community.explore': 'Explorar comunidade',
  'home.community.stats.works': 'Obras',
  'home.community.stats.creators': 'Criadores',
  'home.community.stats.views': 'Visualizações',
  'home.community.image.title': 'Comunidade de imagens IA',
  'home.community.image.description': 'Descubra e compartilhe imagens impressionantes geradas por IA, do fotorrealismo ao artístico, de ilustrações à fotografia',
  'home.community.video.title': 'Comunidade de vídeos IA',
  'home.community.video.description': 'Explore vídeos incríveis gerados por IA, aprenda técnicas criativas e troque experiências com criadores de vídeo globais',
  'home.community.music.title': 'Comunidade de música IA',
  'home.community.music.description': 'Ouça belas melodias compostas por IA, compartilhe suas obras musicais e encontre entusiastas da música com ideias semelhantes',
  'home.community.3d.title': 'Comunidade de modelos 3D IA',
  'home.community.3d.description': 'Explore o mundo dos modelos 3D gerados por IA, da arquitetura a personagens, de jogos ao design industrial',
  'home.community.voice.title': 'Comunidade de voz IA',
  'home.community.voice.description': 'Experimente síntese de voz IA realista, dublagem, audiolivros, clonagem de voz e dê vida às suas criações',
  'home.community.text.title': 'Comunidade de texto IA',
  'home.community.text.description': 'Compartilhe textos excelentes criados por IA, romances, poemas, roteiros, redação publicitária e inspire sua criatividade literária',
  
  // Página de faturação
  'billing.page.title': 'Centro financeiro',
  'billing.page.description': 'Gerencie suas transações e detalhes de faturação',
  'billing.button.refresh': 'Atualizar',
  'billing.button.recharge': 'Recarregar',
  'billing.button.reset': 'Redefinir',
  'billing.button.apply': 'Aplicar filtros',
  'billing.balance.cny': 'Saldo CNY',
  'billing.balance.usdt': 'Saldo USDT',
  'billing.balance.usd': 'Saldo USD',
  'billing.balance.token': 'Saldo de Token',
  'billing.balance.frozen': 'Congelado',
  'billing.type.frozen': 'Fundos congelados',
  'billing.type.aiModelFee': 'Taxa de modelo IA',
  'billing.type.recharge': 'Recarga',
  'billing.type.refund': 'Reembolso',
  'billing.type.reward': 'Recompensa',
  'billing.type.all': 'Todos os tipos',
  'billing.coin.all': 'Todas as moedas',
  'billing.coin.usdt': 'USDT',
  'billing.coin.cny': 'CNY',
  'billing.coin.usd': 'USD',
  'billing.coin.token': 'TOKEN',
  'billing.table.type': 'Tipo',
  'billing.table.coinType': 'Moeda',
  'billing.table.time': 'Hora',
  'billing.table.amount': 'Quantia',
  'billing.table.remark': 'Observação',
  'billing.table.balance': 'Saldo',
  'billing.table.empty': 'Sem registros',
  'billing.filter.title': 'Opções de filtro',
  'billing.filter.button': 'Filtrar e data',
  'billing.filter.changeType': 'Tipo de transação',
  'billing.filter.coinType': 'Tipo de moeda',
  'billing.filter.remark': 'Pesquisa de observação',
  'billing.filter.remarkPlaceholder': 'Digite palavras-chave',
  'billing.filter.remarkSearch': 'Pesquisa de observação',
  'billing.filter.dateQuick': 'Data rápida',
  'billing.filter.dateCustom': 'Data personalizada',
  'billing.filter.dateTo': 'até',
  'billing.filter.days7': 'Últimos 7 dias',
  'billing.filter.days30': 'Últimos 30 dias',
  'billing.filter.days90': 'Últimos 3 meses',
  'billing.placeholder.changeType': 'Tipo de alteração',
  'billing.placeholder.coinType': 'Moeda',
  'billing.placeholder.remark': 'Pesquisa de observação',
  'billing.message.fetchBalanceError': 'Falha ao buscar saldo',
  'billing.message.fetchRecordsError': 'Falha ao buscar registros de faturação',
  'billing.message.tryAgain': 'Falha ao buscar registros de faturação, tente novamente mais tarde',
  
  // Página de recarga
  'recharge.page.title': 'Recarga de conta',
  'recharge.page.backLink': 'Voltar à faturação',
  'recharge.balance.title': 'Saldo da conta',
  'recharge.balance.refresh': 'Atualizar',
  'recharge.section.coinType': 'Moeda de recarga',
  'recharge.section.paymentMethod': 'Método de pagamento',
  'recharge.section.amount': 'Valor de recarga',
  'recharge.order.title': 'Detalhes do pedido',
  'recharge.order.type': 'Tipo de recarga',
  'recharge.order.typeValue': 'Recarga de saldo da conta',
  'recharge.order.account': 'Conta',
  'recharge.order.accountLoading': 'Carregando...',
  'recharge.order.paymentMethod': 'Método de pagamento',
  'recharge.order.paymentMethodPlease': 'Por favor selecione',
  'recharge.order.total': 'Valor total',
  'recharge.button.pay': 'Pagar agora',
  'recharge.button.customize': 'Valor personalizado',
  'recharge.placeholder.customAmount': 'Digite o valor personalizado',
  'recharge.security.ssl': 'Transmissão criptografada SSL, pagamento seguro',
  'recharge.security.agreement': 'Ao clicar em Pagar, você concorda com',
  'recharge.security.agreementLink': 'Acordo de serviço de recarga',
  'recharge.empty.noCurrency': 'Nenhuma moeda suportada',
  'recharge.empty.noPaymentMethod': 'Nenhum método de pagamento disponível para {currency}',
  'recharge.empty.pleaseSelectCurrency': 'Por favor selecione a moeda primeiro',
  'recharge.empty.pleaseSelectPayment': 'Por favor selecione o método de pagamento primeiro',
  'recharge.empty.noProducts': 'Nenhum produto disponível',
  'recharge.empty.noPresets': 'Nenhum valor predefinido para {currency}',
  'recharge.message.invalidAmount': 'Por favor insira um valor válido',
  'recharge.message.selectPaymentMethod': 'Por favor selecione um método de pagamento',
  'recharge.message.selectAmount': 'Por favor selecione o valor de recarga',
  'recharge.message.fetchBalanceError': 'Falha ao buscar saldo, tente novamente mais tarde',
  'recharge.message.fetchUserInfoError': 'Falha ao buscar informações do usuário',
  'recharge.message.fetchCurrenciesError': 'Falha ao buscar moedas, tente novamente mais tarde',
  'recharge.message.fetchPaymentMethodsError': 'Falha ao buscar métodos de pagamento, tente novamente mais tarde',
  'recharge.message.fetchCreemProductsError': 'Falha ao buscar produtos Creem, tente novamente mais tarde',
  'recharge.message.fetchCreemProductsWarning': 'Falha ao buscar produtos Creem',
  'recharge.message.orderCreated': 'Pedido criado com sucesso',
  'recharge.message.orderCreateFailed': 'Falha ao criar pedido de recarga',
  'recharge.message.paymentProcessing': 'Abrindo página de pagamento, complete o pagamento...',
  'recharge.message.popupBlocked': 'Não é possível abrir a janela de pagamento, verifique as configurações de popup do navegador',
  'recharge.message.paymentUrlError': 'Falha ao obter URL de pagamento',
  'recharge.message.checkoutSessionError': 'Falha ao criar sessão de pagamento',
  'recharge.message.paymentError': 'Falha ao processar pagamento, tente novamente mais tarde',
  'recharge.message.redirecting': 'Redirecionando para a página de pagamento, complete o pagamento...',
  'recharge.message.paymentUrlFailed': 'URL de pagamento não disponível',
  'recharge.message.paymentSuccess': 'Pagamento bem-sucedido! Saldo atualizado',
  'recharge.message.orderCancelled': 'Pedido cancelado',
  'recharge.message.paymentFailed': 'Pagamento falhou',
  'recharge.message.orderExpired': 'Expirado',
  'recharge.message.queryOrderError': 'Falha ao consultar status do pedido',
  'recharge.message.rechargeError': 'Falha na solicitação de recarga, tente novamente mais tarde',

  // Página de pedidos
  'orders.title': 'Histórico de pedidos',
  'orders.subtitle': 'Veja todos os seus registros de pedidos de recarga e status',
  'orders.refresh': 'Atualizar',
  'orders.goToRecharge': 'Recarregar',

  // Cartões estatísticos
  'orders.stats.totalOrders': 'Total de pedidos',
  'orders.stats.pending': 'Pendente',
  'orders.stats.paid': 'Pago',
  'orders.stats.totalAmount': 'Total recarregado',

  // Colunas da tabela
  'orders.table.orderNo': 'N° do pedido',
  'orders.table.createTime': 'Criado em',
  'orders.table.amount': 'Valor',
  'orders.table.paymentMethod': 'Método de pagamento',
  'orders.table.status': 'Status',
  'orders.table.action': 'Ação',
  'orders.table.view': 'Ver',
  'orders.table.cancel': 'Cancelar',
  'orders.table.empty': 'Sem registros de pedidos',

  // Status do pedido
  'orders.status.pending': 'Pendente',
  'orders.status.paid': 'Pago',
  'orders.status.success': 'Concluído',
  'orders.status.cancelled': 'Cancelado',
  'orders.status.failed': 'Falhou',
  'orders.status.expired': 'Expirado',
  'orders.status.all': 'Todos os status',

  // Métodos de pagamento
  'orders.payment.alipay': 'Alipay',
  'orders.payment.wechat': 'WeChat Pay',
  'orders.payment.bank': 'Cartão bancário',
  'orders.payment.usdt': 'USDT',
  'orders.payment.creem': 'Creem',
  'orders.payment.all': 'Todos os métodos',

  // Moeda
  'orders.coin.all': 'Todas as moedas',

  // Filtros
  'orders.filter.title': 'Opções de filtro',
  'orders.filter.button': 'Filtrar pedidos',
  'orders.filter.reset': 'Redefinir',
  'orders.filter.apply': 'Aplicar',
  'orders.filter.orderStatus': 'Status do pedido',
  'orders.filter.paymentMethod': 'Método de pagamento',
  'orders.filter.coinType': 'Tipo de moeda',
  'orders.filter.orderNoSearch': 'Pesquisar N° do pedido',
  'orders.filter.quickDate': 'Data rápida',
  'orders.filter.customDate': 'Data personalizada',
  'orders.filter.dateTo': 'até',
  'orders.filter.last7Days': 'Últimos 7 dias',
  'orders.filter.last30Days': 'Últimos 30 dias',
  'orders.filter.last3Months': 'Últimos 3 meses',

  // Pesquisa e entrada
  'orders.search.placeholder': 'Pesquisar número do pedido',
  'orders.input.orderNo': 'Inserir número do pedido',
  'orders.select.orderStatus': 'Status do pedido',
  'orders.select.paymentMethod': 'Método de pagamento',
  'orders.select.coinType': 'Moeda',

  // Mensagens
  'orders.message.fetchError': 'Falha ao buscar pedidos',
  'orders.message.fetchErrorRetry': 'Falha ao buscar pedidos, tente novamente mais tarde',
  'orders.message.statsError': 'Falha ao buscar estatísticas',
  'orders.message.cancelSuccess': 'Pedido cancelado',
  'orders.message.cancelError': 'Falha ao cancelar pedido',
  'orders.message.cancelErrorRetry': 'Falha ao cancelar pedido, tente novamente mais tarde',
  'orders.message.viewOrder': 'N° do pedido: {orderNo}',

  // Diálogo de confirmação
  'orders.confirm.cancel': 'Tem certeza de que deseja cancelar este pedido?',
  'orders.confirm.ok': 'OK',
  'orders.confirm.cancelButton': 'Cancelar',

  // Página Junte-se a nós
  'joinUs.seo.title': 'Junte-se à PROTX - Busca pela excelência',
  'joinUs.seo.description': 'Junte-se à equipe PROTX e busque a experiência do usuário e o design de produto definitivos conosco',
  'joinUs.hero.eyebrow': 'JOIN PROTX',
  'joinUs.hero.title': 'Busca pela excelência',
  'joinUs.hero.title2': 'Definindo o futuro através do design',
  'joinUs.hero.subtitle': 'PROTX é uma equipe dedicada a criar a experiência do usuário e o design de produto definitivos. Acreditamos que cada pixel importa, cada interação merece ser polida meticulosamente. Se você compartilha nossa busca incansável pela excelência, junte-se a nós.',
  'joinUs.hero.cta': 'Ver vagas abertas',
  'joinUs.hero.video': 'Ver nossa história',
  
  'joinUs.values.eyebrow': 'NOSSOS VALORES',
  'joinUs.values.title': 'Nossos valores fundamentais',
  'joinUs.values.subtitle': 'Estes valores fundamentais definem quem somos e como trabalhamos juntos',
  'joinUs.values.innovation.title': 'Movidos pela inovação',
  'joinUs.values.innovation.desc': 'Acreditamos que a inovação é a força que muda o mundo, incentivando cada ideia revolucionária.',
  'joinUs.values.collaboration.title': 'Sucesso colaborativo',
  'joinUs.values.collaboration.desc': 'Colaboração entre equipes para criar juntos resultados extraordinários.',
  'joinUs.values.excellence.title': 'Busca pela excelência',
  'joinUs.values.excellence.desc': 'Superando constantemente limites para a experiência definitiva.',
  'joinUs.values.passion.title': 'Paixão e foco',
  'joinUs.values.passion.desc': 'Amor pela tecnologia, dedicação ao produto.',
  'joinUs.values.impact.title': 'Gerando impacto',
  'joinUs.values.impact.desc': 'Potencializando a expressão criativa de todos com tecnologia IA.',
  
  'joinUs.positions.eyebrow': 'VAGAS ABERTAS',
  'joinUs.positions.title': 'Vagas abertas',
  'joinUs.positions.subtitle': 'Encontre o cargo ideal para você e comece sua nova jornada profissional',
  'joinUs.category.engineering': 'Engenharia',
  'joinUs.category.product': 'Produto e Design',
  'joinUs.category.operations': 'Operações e Marketing',
  'joinUs.position.seniorFrontend': 'Engenheiro Frontend Sênior',
  'joinUs.position.backendEngineer': 'Engenheiro Backend',
  'joinUs.position.mlEngineer': 'Engenheiro IA/ML',
  'joinUs.position.productManager': 'Product Manager',
  'joinUs.position.uxDesigner': 'Designer UX',
  'joinUs.position.communityManager': 'Community Manager',
  'joinUs.position.contentCreator': 'Criador de Conteúdo',
  'joinUs.location.remote': 'Remoto',
  'joinUs.location.beijing': 'Pequim',
  'joinUs.location.shanghai': 'Xangai',
  'joinUs.location.shenzhen': 'Shenzhen',
  'joinUs.type.fulltime': 'Tempo integral',
  'joinUs.type.parttime': 'Meio período',
  
  'joinUs.benefits.eyebrow': 'BENEFÍCIOS',
  'joinUs.benefits.title': 'O que oferecemos',
  'joinUs.benefits.subtitle': 'Junte-se a nós e desfrute de benefícios e suporte abrangentes',
  'joinUs.benefit.flexible.title': 'Trabalho flexível',
  'joinUs.benefit.flexible.desc': 'Horários flexíveis e opções de trabalho remoto',
  'joinUs.benefit.equity.title': 'Stock options',
  'joinUs.benefit.equity.desc': 'Cresça com a empresa e compartilhe nosso sucesso',
  'joinUs.benefit.health.title': 'Plano de saúde',
  'joinUs.benefit.health.desc': 'Plano de saúde completo e benefícios de bem-estar',
  'joinUs.benefit.growth.title': 'Crescimento profissional',
  'joinUs.benefit.growth.desc': 'Oportunidades contínuas de aprendizado e desenvolvimento',
  
  'joinUs.cta.title': 'Pronto para começar?',
  'joinUs.cta.subtitle': 'Se você é apaixonado por nossa missão, aguardamos sua candidatura',
  'joinUs.cta.button': 'Candidatar-se agora',
  
  'joinUs.modal.title': 'Candidatura',
  'joinUs.apply.success': 'Candidatura enviada! Entraremos em contato em breve.',
  'joinUs.form.name': 'Nome',
  'joinUs.form.name.required': 'Por favor insira seu nome',
  'joinUs.form.name.placeholder': 'Insira seu nome',
  'joinUs.form.email': 'E-mail',
  'joinUs.form.email.required': 'Por favor insira seu e-mail',
  'joinUs.form.email.invalid': 'Por favor insira um e-mail válido',
  'joinUs.form.email.placeholder': 'Insira seu e-mail',
  'joinUs.form.phone': 'Telefone',
  'joinUs.form.phone.placeholder': 'Insira seu número de telefone',
  'joinUs.form.experience': 'Experiência profissional',
  'joinUs.form.experience.placeholder': 'Selecione seu nível de experiência',
  'joinUs.form.experience.0-2': '0-2 anos',
  'joinUs.form.experience.3-5': '3-5 anos',
  'joinUs.form.experience.5-10': '5-10 anos',
  'joinUs.form.experience.10+': '10+ anos',
  'joinUs.form.resume': 'Currículo',
  'joinUs.form.resume.hint': 'Clique ou arraste o arquivo para carregar',
  'joinUs.form.resume.format': 'Formatos PDF, DOC, DOCX suportados',
  'joinUs.form.message': 'Carta de apresentação',
  'joinUs.form.message.placeholder': 'Conte-nos sobre você e por que deseja se juntar a nós',
  'joinUs.form.submit': 'Enviar candidatura',
  'joinUs.form.loginTip': 'Faça login antes de enviar para acompanhar sua candidatura',
  'joinUs.form.goLogin': 'Entrar',
  'joinUs.form.resume.sizeLimit': 'O tamanho do arquivo não pode exceder 10 MB',
  
  // Minhas candidaturas
  'joinUs.myApplications.eyebrow': 'MINHAS CANDIDATURAS',
  'joinUs.myApplications.title': 'Histórico de candidaturas',
  'joinUs.myApplications.empty': 'Nenhuma candidatura ainda. Envie seu currículo agora!',
  'joinUs.myApplications.viewDetail': 'Ver detalhes',
  'joinUs.myApplications.detailTitle': 'Detalhes da candidatura',
  'joinUs.status.pending': 'Pendente',
  'joinUs.status.reviewing': 'Em análise',
  'joinUs.status.interview': 'Entrevista',
  'joinUs.status.accepted': 'Aceito',
  'joinUs.status.rejected': 'Rejeitado',
  'joinUs.detail.basicInfo': 'Informações básicas',
  'joinUs.detail.positionInfo': 'Informações da vaga',
  'joinUs.detail.position': 'Vaga solicitada',
  'joinUs.detail.category': 'Categoria',
  'joinUs.detail.location': 'Localização',
  'joinUs.detail.applyTime': 'Data da candidatura',
  'joinUs.detail.downloadResume': 'Baixar currículo',
  'joinUs.detail.status': 'Status da candidatura',

  // Página About
  'about.hero.title1': 'Núcleo Open Source.',
  'about.hero.title2': 'Possibilidades infinitas.',
  'about.hero.subtitle1': 'Baseado em',
  'about.hero.subtitle2': 'e',
  'about.hero.subtitle3': 'ecossistema.',
  'about.hero.description': 'Empacotamos a pilha tecnológica de IA generativa mais avançada de 2025 em uma experiência interativa definitiva.',
  'about.tech.poweredBy': 'Powered by',
  'about.philosophy.title1': 'Mais do que geração.',
  'about.philosophy.title2': 'Este é um processo completo',
  'about.philosophy.title3': 'motor de criatividade.',
  'about.philosophy.description': 'Do controle preciso em texto-para-imagem à simulação física na geração de vídeo, perseguimos os limites da tecnologia.',
  'about.bento.comfy.title': 'Controle de precisão a nível de nós.',
  'about.bento.comfy.description': 'Construído sobre a arquitetura de nós ComfyUI, suportando controle de pose ControlNet e transferência de estilo IP-Adapter. Encapsulamos a lógica complexa de nós em controles deslizantes intuitivos, tornando cada geração exatamente como você imagina.',
  'about.bento.opensource.title': 'Abraçar o código aberto.',
  'about.bento.opensource.description': 'Baseado no Stable Diffusion 3.5 & XL Turbo. Não apenas geração ultrarrápida, mas também suporte massivo de modelos LoRA da comunidade.',
  'about.bento.video.title': 'Arquitetura de vídeo DiT.',
  'about.bento.video.description': 'Introduzindo Diffusion Transformer (DiT) com mecanismo de atenção espaço-temporal, alcançando simulação do mundo físico a nível SORA.',
  'about.bento.audio.title': 'Sincronização audiovisual, despertar sensorial.',
  'about.bento.audio.description': 'Além do visual. Integrado com os mais recentes modelos de geração de áudio, suportando Text-to-Audio e alinhamento automático de vídeo. Da visão ao som, construindo uma experiência imersiva completa.',
  'about.techSection.title': 'Arquitetura técnica.',
  'about.techSection.description': 'Mergulhe no motor central que alimenta o ProductX.',
  'about.techCard.sd.title': 'A fundação da arte generativa.',
  'about.techCard.sd.description': 'Integramos profundamente os mais recentes modelos de geração Stable Diffusion. Através de VAE personalizado e samplers otimizados, alcançamos geração 300% mais rápida mantendo qualidade de imagem requintada.',
  'about.techCard.spec.baseModel': 'Modelo base',
  'about.techCard.spec.resolution': 'Resolução',
  'about.techCard.spec.resolution.value': 'Até 4K Upscaling',
  'about.techCard.spec.control': 'Controle',
  'about.techCard.spec.speed': 'Velocidade',
  'about.techCard.spec.speed.value': '< 1s (Modo Turbo)',
  'about.techCard.video.title': 'Motor de física de vídeo de próxima geração.',
  'about.techCard.video.description': 'Abandonando a lógica tradicional de animação 2D, adotando a mais recente arquitetura DiT (Diffusion Transformer) de 2025. O modelo entende iluminação, gravidade e física do movimento, gerando não apenas vídeos, mas mundos dinâmicos fisicamente precisos.',
  'about.techCard.spec.architecture': 'Arquitetura',
  'about.techCard.spec.frameRate': 'Taxa de quadros',
  'about.techCard.spec.frameRate.value': 'Interpolação 24 / 60 FPS',
  'about.techCard.spec.consistency': 'Consistência',
  'about.techCard.spec.consistency.value': 'Alta estabilidade temporal',
  'about.techCard.spec.length': 'Duração',
  'about.techCard.spec.length.value': 'Extensão de loop infinito',
  'about.techCard.img2img.title': 'Imagem-para-imagem e transferência de estilo.',
  'about.techCard.img2img.description': 'Usando tecnologias IP-Adapter e T2I-Adapter, alcançamos transferência de estilo zero-shot. Carregue uma imagem de referência para replicar instantaneamente sua composição, iluminação e estilo artístico, liberando possibilidades criativas infinitas.',
  'about.techCard.spec.technology': 'Tecnologia',
  'about.techCard.spec.precision': 'Precisão',
  'about.techCard.spec.precision.value': 'Inpainting pixel-perfeito',
  'about.cta.title': 'Pronto para experimentar o futuro?',
  'about.cta.description': 'Junte-se às fileiras de criadores profissionais e liberte o potencial definitivo da IA.',
  'about.cta.button.start': 'Começar',
  'about.cta.button.docs': 'Ler documentação',
  
  // Community
  'community.explore.title': 'Explorar comunidades',
  'community.explore.subtitle': 'Descubra inspiração, remixe fluxos de trabalho e conecte-se com milhares de criadores de IA.',
  'community.posts': '{count} publicações',
  'community.empty': 'Nenhum canal da comunidade',
  'community.loadFailed': 'Falha ao carregar',
  'community.noPosts': 'Ainda não há publicações',
  'community.challenge.loadFailed': 'Falha ao carregar dados do desafio',
  
  'common.loadFailed': 'Falha ao carregar',
  'common.operationFailed': 'Operação falhou',
  'common.error': 'Operação falhou',
  'common.publish': 'Publicar',
  'common.back': 'Voltar',
  'common.backToCommunity': 'Voltar à comunidade',
  'common.copy': 'Copiar',
  'common.copied': 'Copiado',
  'common.follow': 'Seguir',
  'common.processing': 'Processando...',
  'common.viewCount': '{count} visualizações',
  'common.loadMore': 'Carregar mais',
  'common.search': 'Pesquisar...',
  'common.notFound': 'Não encontrado',
  'common.description': 'Descrição',
  
  'user.followSuccess': 'Seguido com sucesso',
  'user.unfollowSuccess': 'Deixado de seguir com sucesso',
  'user.following': 'Seguindo',
  'user.mutual_follow': 'Mútuo',
  
  'post.untitled': 'Criação sem título',
  'post.prompt': 'Prompt',
  'post.negativePrompt': 'Prompt negativo',
  'post.details': 'Detalhes',
  'post.model': 'Modelo',
  'post.resolution': 'Resolução',
  'post.steps': 'Passos',
  'post.cfgScale': 'Escala de orientação',
  'post.remix': 'Remix / Experimentar isto',
  
  'challenge.status.upcoming': 'Em breve',
  'challenge.status.live': 'Ao vivo',
  'challenge.status.voting': 'Votação',
  'challenge.status.ended': 'Terminado',
  'challenge.status.unknown': 'Desconhecido',
  'challenge.allChallenges': 'Todos os desafios',
  'challenge.entriesCount': '{count} participações',
  'challenge.tab.submissions': 'Participações',
  'challenge.tab.rules': 'Regras e informações',
  'challenge.requirements': 'Requisitos',
  'challenge.req.original': 'Apenas criações originais.',
  'challenge.req.model': 'Deve usar o modelo: {model}',
  'challenge.req.tags': 'Deve incluir tags:',
  'challenge.req.resolution': 'A resolução deve ser pelo menos 1024x1024.',
  'challenge.req.nsfw': 'Sem conteúdo NSFW.',
  'challenge.timeRemaining': 'Tempo restante',
  'challenge.startsIn': 'Inicia em',
  'challenge.notStarted': 'Desafio ainda não iniciado',
  'challenge.closed': 'Desafio fechado',
  'challenge.submitEntry': 'Enviar participação',
  'challenge.viewWinners': 'Ver vencedores',
  'challenge.readRulesTip': 'Leia as regras antes de enviar',
  'challenge.prizePool': 'Prêmio',
  'challenge.totalValue': 'Valor total',
  'challenge.rank.1st': '1º lugar',
  'challenge.rank.2nd': '2º lugar',
  'challenge.rank.3rd': '3º lugar',
  'challenge.share': 'Compartilhar desafio',
  'challenge.noEntries': 'Ainda não há participações. Seja o primeiro!',
  'challenge.noChallenges': 'Nenhum desafio encontrado',
  // MediaTools
  'mediaTools.tab.imageCompress': 'Compressão de imagem',
  'mediaTools.tab.videoCompress': 'Compressão de vídeo',
  'mediaTools.tab.audioCompress': 'Compressão de áudio',
  'mediaTools.tab.formatConvert': 'Conversão de formato',
  // ImageCompress
  'imageCompress.title': 'Ferramenta profissional de compressão de imagens',
  'imageCompress.subtitle': 'Compressão inteligente, qualidade profissional',
  'imageCompress.upload': 'Carregar imagens',
  'imageCompress.addImages': 'Adicionar imagens',
  'imageCompress.uploadToStart': 'Carregue imagens para começar a compressão',
  'imageCompress.settings': 'Configurações',
  'imageCompress.clearAll': 'Limpar tudo',
  'imageCompress.totalSavings': 'Espaço economizado',
  'imageCompress.totalSize': 'Tamanho total',
  'imageCompress.quality': 'Qualidade',
  'imageCompress.resize': 'Redimensionar',
  'imageCompress.scalePercent': 'Escala %',
  'imageCompress.customPx': 'Px personalizado',
  'imageCompress.presetSize': 'Tamanho predefinido',
  'imageCompress.width': 'Largura',
  'imageCompress.height': 'Altura',
  'imageCompress.format': 'Formato',
  'imageCompress.format.auto': 'Automático (original)',
  'imageCompress.format.jpeg': 'JPEG (foto)',
  'imageCompress.format.png': 'PNG (sem perda)',
  'imageCompress.format.webp': 'WebP (melhor)',
  'imageCompress.pngLossless': 'PNG é sem perda. O controle de qualidade está oculto.',
  'imageCompress.cacheSettings': 'Configurações de cache',
  'imageCompress.cacheTooltip': 'Quando habilitado, as imagens carregadas serão salvas no cache do navegador e restauradas após atualizar a página.',
  'imageCompress.saveToCache': 'Salvar imagens no cache do navegador',
  'imageCompress.batchProcessing': 'Processamento em lote',
  'imageCompress.batchTooltip': 'Quando habilitado, a compressão será aplicada a todas as {count} imagens com as configurações atuais.',
  'imageCompress.applyToAll': 'Aplicar configurações a todas as imagens ({count})',
  'imageCompress.compress': 'Aplicar e comprimir',
  'imageCompress.compressAll': 'Aplicar e comprimir tudo ({count})',
  'imageCompress.compressing': 'Comprimindo...',
  'imageCompress.compressAllProgress': 'Comprimindo {count} imagens...',
  'imageCompress.download': 'Baixar imagem',
  'imageCompress.downloadAll': 'Baixar tudo ({count})',
  'imageCompress.downloadAllCheckbox': 'Baixar todas as {count} imagens',
  'imageCompress.original': 'Original',
  'imageCompress.compressed': 'Comprimido',
  // Messages
  'imageCompress.message.compressed': 'Compressão bem-sucedida!',
  'imageCompress.message.larger': 'O arquivo de saída é maior. Tente reduzir a qualidade.',
  'imageCompress.message.failed': 'Falha na compressão',
  'imageCompress.message.batchSuccess': '{success} imagem(ns) comprimida(s) com sucesso{failed}',
  'imageCompress.message.batchFailed': 'Todas as compressões falharam',
  'imageCompress.message.noImagesToDownload': 'Nenhuma imagem comprimida para baixar',
  'imageCompress.message.downloading': 'Baixando {count} imagem(ns)...',
  // Preset sizes
  'imageCompress.preset.instagramPost': 'Post do Instagram (1:1)',
  'imageCompress.preset.square': 'Quadrado (1:1)',
  'imageCompress.preset.facebookCover': 'Capa do Facebook (16:9)',
  'imageCompress.preset.twitterHeader': 'Cabeçalho do Twitter (3:1)',
  'imageCompress.preset.youtubeThumbnail': 'Miniatura do YouTube (16:9)',
  'imageCompress.preset.facebookPost': 'Post do Facebook (1.91:1)',
  'imageCompress.preset.instagramStory': 'Story do Instagram (9:16)',
  'imageCompress.preset.tiktok': 'TikTok (9:16)',
  'imageCompress.preset.4kUHD': '4K UHD (16:9)',
  'imageCompress.preset.2kQHD': '2K QHD (16:9)',
  'imageCompress.preset.fullHD': 'Full HD (16:9)',
  'imageCompress.preset.hd': 'HD (16:9)',
  'imageCompress.preset.landscape16:9': 'Paisagem 16:9',
  'imageCompress.preset.classic4:3': 'Clássico 4:3',
  'imageCompress.preset.photo3:2': 'Foto 3:2',
  'imageCompress.preset.ultrawide21:9': 'Ultrawide 21:9',
  'imageCompress.preset.a4Portrait': 'A4 Retrato (8.27×11.69")',
  'imageCompress.preset.a4Landscape': 'A4 Paisagem (11.69×8.27")',
  'imageCompress.preset.letterPortrait': 'Letter Retrato (8.5×11")',
  // AudioCompress
  'audioCompress.title': 'Ferramenta profissional de compressão de áudio',
  'audioCompress.subtitle': 'Compressão baseada no navegador, privacidade protegida',
  'audioCompress.upload': 'Carregar áudio',
  'audioCompress.uploadNew': 'Clique para carregar novo áudio',
  'audioCompress.uploadToStart': 'Carregue áudio para iniciar a compressão',
  'audioCompress.settings': 'Configurações',
  'audioCompress.clearAll': 'Limpar tudo',
  'audioCompress.totalSavings': 'Espaço economizado',
  'audioCompress.totalSize': 'Tamanho total',
  'audioCompress.audioInfo': 'Info de áudio',
  'audioCompress.quality': 'Qualidade',
  'audioCompress.bitrate': 'Taxa de bits',
  'audioCompress.bitrate.320': '320 kbps (Qualidade máxima)',
  'audioCompress.bitrate.256': '256 kbps (Alta qualidade)',
  'audioCompress.bitrate.192': '192 kbps (Qualidade padrão)',
  'audioCompress.bitrate.128': '128 kbps (Qualidade média)',
  'audioCompress.bitrate.96': '96 kbps (Baixa qualidade)',
  'audioCompress.bitrate.64': '64 kbps (Qualidade mínima)',
  'audioCompress.format': 'Formato',
  'audioCompress.format.mp3': 'MP3 (Recomendado)',
  'audioCompress.format.ogg': 'OGG',
  'audioCompress.format.aac': 'AAC',
  'audioCompress.format.wav': 'WAV',
  'audioCompress.sampleRate': 'Taxa de amostragem',
  'audioCompress.sampleRate.48000': '48000 Hz',
  'audioCompress.sampleRate.44100': '44100 Hz (Qualidade CD)',
  'audioCompress.sampleRate.32000': '32000 Hz',
  'audioCompress.sampleRate.22050': '22050 Hz',
  'audioCompress.sampleRate.16000': '16000 Hz',
  'audioCompress.compress': 'Iniciar compressão',
  'audioCompress.compressing': 'Comprimindo...',
  'audioCompress.download': 'Baixar áudio',
  // AudioCompress Messages
  'audioCompress.message.compressed': 'Compressão bem-sucedida!',
  'audioCompress.message.failed': 'Compressão falhou, tente novamente',
  'audioCompress.message.invalidFile': 'Selecione um arquivo de áudio!',
  'audioCompress.message.loadError': 'Falha ao carregar o arquivo de áudio',

  // Settings
  'settings.title': 'Definições do sistema',
  'settings.description': 'Personalize a sua experiência na plataforma AI',
  'settings.notifications.title': 'Notificações',
  'settings.notifications.description': 'Gerir como recebe notificações',
  'settings.notifications.email': 'Email',
  'settings.notifications.emailDesc': 'Receber atualizações e conclusão de tarefas',
  'settings.notifications.push': 'Push',
  'settings.notifications.pushDesc': 'Receber mensagens push em tempo real',
  'settings.notifications.sound': 'Som',
  'settings.notifications.soundDesc': 'Reproduzir som na notificação',
  'settings.notifications.volume': 'Volume das notificações',
  'settings.notifications.volumeDesc': 'Ajustar volume',
  'settings.notifications.marketing': 'Marketing',
  'settings.notifications.marketingDesc': 'Eventos e promoções da plataforma',
  'settings.interface.title': 'Aparência',
  'settings.interface.description': 'Personalizar a interface',
  'settings.interface.theme': 'Tema',
  'settings.interface.themeDesc': 'Escolher o tema',
  'settings.interface.language': 'Idioma',
  'settings.interface.languageDesc': 'Idioma da interface',
  'settings.interface.animation': 'Animações',
  'settings.interface.animationDesc': 'Ativar animações de transição',
  'settings.interface.tips': 'Dicas',
  'settings.interface.tipsDesc': 'Mostrar guias e dicas',
  'settings.theme.light': 'Claro',
  'settings.theme.dark': 'Escuro',
  'settings.theme.auto': 'Automático',
  'settings.ai.title': 'Definições de geração AI',
  'settings.ai.description': 'Otimizar qualidade e desempenho',
  'settings.ai.autoOptimize': 'Otimização automática',
  'settings.ai.autoOptimizeDesc': 'A AI otimiza parâmetros automaticamente',
  'settings.ai.quality': 'Qualidade de geração',
  'settings.ai.qualityDesc': 'Equilíbrio velocidade/qualidade',
  'settings.ai.cloudSync': 'Sincronização na nuvem',
  'settings.ai.cloudSyncDesc': 'Sincronizar obras na nuvem',
  'settings.ai.autoSave': 'Guardar automaticamente',
  'settings.ai.autoSaveDesc': 'Guardar resultados após geração',
  'settings.ai.safetyFilter': 'Filtro de conteúdo',
  'settings.ai.safetyFilterDesc': 'Filtrar conteúdo inadequado',
  'settings.ai.watermark': 'Marca de água',
  'settings.ai.watermarkDesc': 'Adicionar marca de água às obras',
  'settings.ai.promptSuggestions': 'Sugestões de prompt',
  'settings.ai.promptSuggestionsDesc': 'Sugestões para otimizar prompts',
  'settings.quality.fast': 'Rápido',
  'settings.quality.balanced': 'Equilibrado',
  'settings.quality.high': 'Alta qualidade',
  'settings.privacy.title': 'Privacidade e segurança',
  'settings.privacy.description': 'Proteger os seus dados pessoais',
  'settings.privacy.profile': 'Visibilidade do perfil',
  'settings.privacy.profileDesc': 'Outros podem ver o seu perfil',
  'settings.privacy.activity': 'Estado de atividade',
  'settings.privacy.activityDesc': 'Contactos veem se está online',
  'settings.privacy.analytics': 'Recolha de dados analíticos',
  'settings.privacy.analyticsDesc': 'Ajudar a melhorar o produto',
  'settings.privacy.showWorks': 'Visibilidade das obras',
  'settings.privacy.showWorksDesc': 'Outros podem ver as suas obras',
  'settings.privacy.allowComments': 'Permitir comentários',
  'settings.privacy.allowCommentsDesc': 'Outros podem comentar',
  'settings.privacy.allowDownload': 'Permitir descarga',
  'settings.privacy.allowDownloadDesc': 'Outros podem descarregar',
  'settings.performance.title': 'Desempenho',
  'settings.performance.description': 'Ajustar desempenho do sistema',
  'settings.performance.hardware': 'Aceleração por hardware',
  'settings.performance.hardwareDesc': 'Usar aceleração GPU',
  'settings.performance.preview': 'Qualidade da pré-visualização',
  'settings.performance.previewDesc': 'Nível de qualidade da pré-visualização',
  'settings.performance.autoClean': 'Limpeza automática de cache',
  'settings.performance.autoCleanDesc': 'Eliminar ficheiros temporários periodicamente',
  'settings.performance.imageCompression': 'Compressão de imagens',
  'settings.performance.imageCompressionDesc': 'Comprimir imagens carregadas',
  'settings.performance.lazyLoading': 'Carregamento tardio',
  'settings.performance.lazyLoadingDesc': 'Carregar conteúdo com atraso',
  'settings.preview.low': 'Baixo',
  'settings.preview.medium': 'Médio',
  'settings.preview.high': 'Alto',
  'settings.workflow.title': 'Fluxo de trabalho',
  'settings.workflow.description': 'Personalizar fluxo de geração AI',
  'settings.workflow.resolution': 'Resolução predefinida',
  'settings.workflow.resolutionDesc': 'Tamanho predefinido para imagens',
  'settings.workflow.saveHistory': 'Guardar histórico',
  'settings.workflow.saveHistoryDesc': 'Guardar parâmetros e prompts',
  'settings.workflow.autoTag': 'Tags inteligentes',
  'settings.workflow.autoTagDesc': 'Adicionar tags automaticamente',
  'settings.workflow.template': 'Modelos',
  'settings.workflow.templateDesc': 'Ativar modelos de fluxo',
  'settings.file.title': 'Gestão de ficheiros',
  'settings.file.description': 'Armazenamento e cópias de segurança',
  'settings.file.autoBackup': 'Cópia de segurança automática',
  'settings.file.autoBackupDesc': 'Fazer cópia de ficheiros importantes',
  'settings.file.backupFrequency': 'Frequência de cópias',
  'settings.file.backupFrequencyDesc': 'Escolher frequência',
  'settings.file.realtime': 'Tempo real',
  'settings.file.daily': 'Diário',
  'settings.file.weekly': 'Semanal',
  'settings.file.autoOrganize': 'Organização automática',
  'settings.file.autoOrganizeDesc': 'Categorizar ficheiros automaticamente',
  'settings.file.defaultFormat': 'Formato predefinido',
  'settings.file.defaultFormatDesc': 'Formato de gravação predefinido',
  'settings.social.title': 'Social',
  'settings.social.description': 'Funções sociais e permissões',
  'settings.social.allowFollow': 'Permitir seguir',
  'settings.social.allowFollowDesc': 'Outros podem seguir',
  'settings.social.allowMessage': 'Permitir mensagens',
  'settings.social.allowMessageDesc': 'Outros podem enviar mensagens',
  'settings.social.likeNotify': 'Notificações de gosto',
  'settings.social.likeNotifyDesc': 'Notificar quando receber gostos',
  'settings.social.mentionNotify': 'Notificações de menção',
  'settings.social.mentionNotifyDesc': 'Notificar quando for mencionado',
  'settings.security.title': 'Segurança da conta',
  'settings.security.description': 'Reforçar segurança',
  'settings.security.twoFactor': 'Autenticação em dois fatores',
  'settings.security.twoFactorDesc': 'Camada extra de segurança',
  'settings.security.loginNotify': 'Notificações de início de sessão',
  'settings.security.loginNotifyDesc': 'Notificar início de sessão em novo dispositivo',
  'settings.security.deviceVerify': 'Verificação de dispositivo',
  'settings.security.deviceVerifyDesc': 'Dispositivos não autorizados requerem verificação',
  'settings.security.autoLogout': 'Terminar sessão automaticamente',
  'settings.security.autoLogoutDesc': 'Sair após inatividade prolongada',
  'settings.button.save': 'Guardar',
  'settings.button.reset': 'Repor',
  'settings.badge.on': 'Ativo',
  'settings.badge.recommended': 'Recomendado',
  'settings.message.saveSuccess': 'Definições guardadas',
  'settings.message.autoSaved': 'Definições guardadas automaticamente',
  'settings.message.saveFailed': 'Falha ao guardar',
  'settings.message.resetSuccess': 'Definições repostas',
  'settings.autoSaveHint': 'As definições são guardadas automaticamente',
  'settings.confirm.resetTitle': 'Confirmar repor',
  'settings.confirm.resetContent': 'Repor todas as definições aos valores predefinidos?',
  'settings.confirm.reset': 'Repor',
  'settings.confirm.cancel': 'Cancelar',

  // Prompt Version History
  'prompt.version.label.prompt': 'Prompt',
  'prompt.version.label.negativePrompt': 'Prompt Negativo',
  'prompt.version.label.result': 'Resultado',
}; 